<template>
  <!--<div id="indexBox">-->
  <!--<el-container class="wmCloudsWrapper">-->
  <!--<app-header></app-header>-->
  <!--<div id="layoutBoxMail">-->
  <!--<el-container class="wmCloudsContant">-->
  <!--&lt;!&ndash; 邮箱左侧导航 &ndash;&gt;-->
  <!--<app-aside></app-aside>-->
  <!--&lt;!&ndash; 设置左侧导航 &ndash;&gt;-->
  <!--<asideSet style="display:none;"></asideSet>-->
  <el-container>
    <div class="flexbox wmCloudsMain">
      <div class="wmCloudsBox">
        <!-- 操作栏 -->
        <div class="actionBar flexBetween">
          <!-- 左侧 -->
          <div class="actionBarLeft">
            <!-- 发送按钮 -->
            <el-button v-if="sendType !== sendTypeDISABLE" type="primary" size="small" icon="el-icon-s-promotion" @click="sendMail"
                       v-show="!sendOtherOption.timing">{{$t("wm_lang_html_1535fc")}}
            </el-button>
            <el-button v-if="sendType === sendTypeDISABLE" type="info" disabled size="small" icon="el-icon-s-promotion">{{$t("wm_lang_html_1535fc")}}</el-button>
            <el-button type="primary" size="small" icon="el-icon-s-promotion" @click="sendMail" v-show="sendOtherOption.timing">{{$t("wm_lang_html_74e5c0")}}</el-button>
            <!-- 保存草稿按钮 -->
            <el-button size="small" @click="draftMail">{{$t("wm_lang_html_4d7ea6")}}</el-button>
            <!-- 取消按钮 -->
            <el-button size="small" @click="cancelSend">{{$t("wm_lang_html_625fb2")}}</el-button>
          </div>
          <!-- 右侧 -->
          <div class="actionBarRight flexBetween">
            <!--<el-link :underline="false" icon="el-icon-circle-close" title=this.$i18n.t('wm_lang_b15d91') style="font-size:20px!important;padding:0 5px!important;"></el-link>-->
          </div>
        </div>
        <!-- 如下代码需要做判断，如果是首页加homeCloudsCount CLASS；其它页面加wmCloudsCount  CLASS -->
        <div class="flexbox wmCloudsCount">
          <div class="mainBar nice_scroll">
            <!-- 写信 -->
            <div class="writeBox">
              <div class="writemailtop">
                <el-form ref="form" :model="form" label-width="80px" size="medium">
                  <el-form-item :label="$i18n.t('wm_lang_ac1e1c')">
                    <div class="flexCenter">
                      <div ref="recDiv" class="tagit-box" @click="focusInputPos('rec',-1)">
                        <draggable v-model="form.receiverLabel" group="rcptLabel" animation="100">
                          <transition-group>
                            <div v-for="(item, index) in form.receiverLabel" :key="index" class="addr-div">
                              <div v-if="form.recInputPos===index" class="tagit-mevt tagit-new addr-div">
                                <input type="text" :ref="`recInput${index}`" data-ipt="rec" :style="{width: inputWidth(form.receiver) }"
                                       v-model="form.receiver" @click.stop="stopBubble($event)" @blur="addresseeLabel('rec')"
                                       @keydown="addrKeydown($event, 'rec')" @keyup="addrKeyup($event, 'rec')"
                                       v-on:input="onChangeAutocompleteFilterText" autocomplete="off" class="el-input__inner">
                              </div>
                              <div @click.stop="focusInputPos('rec', index)" class="addr-div" style="cursor:text;">
                                &nbsp;&nbsp;&nbsp;
                              </div>
                              <div @click.stop="selectLabel(item.org)" @dblclick.stop="editLabel(item, $event)"
                                   :item="item" total="" title="" class="tagit-mevt tagit-choice addr-div"
                                   :class="`${item.org === selectedLabel ? ' selected ' : ''}${isErrorAddress(item) ? ' error ' : ''}${item.org === dblclickLabel && editingLabel ? ' label-editing' : ''}`">
                                <span>{{ item.name }}</span>
                                <input type="text" v-focus v-if="item.org === dblclickLabel && editingLabel"
                                       v-model="currEditLabelVal"
                                       @click.stop="stopBubble($event)"
                                       @focus="editLabelFocus" @blur="addresseeLabelEdit('rec', index)"
                                       @keyup="addrEditKeyup($event, 'rec')"
                                       :style="{width: inputWidth(currEditLabelVal) }"/>
                                <span @click="removeRcpts(index, 'rec')" class="tagit-box-close">x</span>
                              </div>
                            </div>
                          </transition-group>
                        </draggable>
                        <div v-if="form.recInputPos<0" class="tagit-mevt tagit-new" style="float:left;">
                          <input type="text" ref="recInput" data-ipt="rec" v-model="form.receiver"
                                 :style="{width: inputWidth(form.receiver) }"
                                 @click.stop="stopBubble($event)" @blur="addresseeLabel('rec')"
                                 @keydown="addrKeydown($event, 'rec')" @keyup="addrKeyup($event, 'rec')"
                                 v-on:input="onChangeAutocompleteFilterText" autocomplete="off" class="el-input__inner">
                        </div>
                      </div>
                      <div class="addBtnBox">
                        <el-button icon="el-icon-plus" @click="selectContactHandle" tabindex="-1"></el-button>
                      </div>
                    </div>
                    <!-- 检索列表 -->
                    <div v-show="enableAutocompleteRec && autocompleteItems.length > 0" id="writeMailAutocompleteRec"
                         ref="writeMailAutocompleteRec"
                         class="tagit-autocomplete nice_scroll" style="">
                      <ul>
                        <li v-for="(item, index) in autocompleteItems" :key="index" :item="item" @click.prevent="addRcpts(item, 'rec')"
                            :class="autocompleteItemsIndex === index ? 'li-autocomplete is-curr' : 'li-autocomplete'">
                          <span>{{ item.first }}<strong class="strong-autocomplete">{{ item.mid }}</strong>{{ item.last }}</span>
                          <br><span class="grayDepartment">{{ item.departsLabel }}</span>
                        </li>
                        <li v-if="autocompleteItems.length === 0"><span
                            class="el-checkbox__label note-association">{{$t("wm_lang_html_ab9ed8")}}</span></li>
                        <li v-if="autocompleteItems.length >= 200"><span
                            class="el-checkbox__label note-association">{{$t("wm_lang_html_5120e6")}}{{
                            autocompleteItems.length
                          }}条匹配，请输入更多信息以缩小范围</span>
                        </li>
                      </ul>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$i18n.t('wm_lang_c00500')">
                    <div class="flexCenter">
                      <div ref="ccDiv" class="tagit-box" @click="focusInputPos('cc',-1)">
                        <draggable v-model="form.ccLabel" group="rcptLabel" animation="100">
                          <transition-group>
                            <div v-for="(item, index) in form.ccLabel" :key="index" class="addr-div">
                              <div v-if="form.ccInputPos===index" class="tagit-mevt tagit-new addr-div">
                                <input type="text" :ref="`ccInput${index}`" data-ipt="cc" :style="{width: inputWidth(form.cc) }"
                                       v-model="form.cc" @click.stop="stopBubble($event)" @blur="addresseeLabel('cc')"
                                       @keydown="addrKeydown($event, 'cc')" @keyup="addrKeyup($event, 'cc')"
                                       v-on:input="onChangeAutocompleteFilterText" autocomplete="off" class="el-input__inner">
                              </div>
                              <div @click.stop="focusInputPos('cc', index)" class="addr-div" style="cursor:text;">
                                &nbsp;&nbsp;&nbsp;
                              </div>
                              <div @click.stop="selectLabel(item.org)" @dblclick.stop="editLabel(item, $event)"
                                   :item="item" total="" title="" class="tagit-mevt tagit-choice addr-div"
                                   :class="`${item.org === selectedLabel ? ' selected ' : ''}${isErrorAddress(item) ? ' error ' : ''}${item.org === dblclickLabel && editingLabel ? ' label-editing' : ''}`">
                                <span>{{ item.name }}</span>
                                <input type="text" v-focus v-if="item.org === dblclickLabel && editingLabel"
                                       v-model="currEditLabelVal"
                                       @click.stop="stopBubble($event)"
                                       @focus="editLabelFocus" @blur="addresseeLabelEdit('cc', index)"
                                       @keyup="addrEditKeyup($event, 'cc')"
                                       :style="{width: inputWidth(currEditLabelVal) }"/>
                                <span @click="removeRcpts(index, 'cc')" class="tagit-box-close">x</span>
                              </div>
                            </div>
                          </transition-group>
                        </draggable>
                        <div v-if="form.ccInputPos<0" class="tagit-mevt tagit-new" style="float:left;">
                          <input type="text" ref="ccInput" data-ipt="cc" v-model="form.cc"
                                 :style="{width: inputWidth(form.cc) }"
                                 @click.stop="stopBubble($event)" @blur="addresseeLabel('cc')"
                                 @keydown="addrKeydown($event, 'cc')" @keyup="addrKeyup($event, 'cc')"
                                 v-on:input="onChangeAutocompleteFilterText" autocomplete="off" class="el-input__inner">
                        </div>
                      </div>
                      <div class="addBtnBox">
                        <el-button icon="el-icon-plus" @click="selectContactHandle" tabindex="-1"></el-button>
                      </div>
                    </div>
                    <!-- 检索列表 -->
                    <div v-show="enableAutocompleteCc && autocompleteItems.length > 0" id="writeMailAutocompleteCc"
                         ref="writeMailAutocompleteCc"
                         class="tagit-autocomplete nice_scroll" style="">
                      <ul>
                        <li v-for="(item, index) in autocompleteItems" :key="index" :item="item" @click.prevent="addRcpts(item, 'cc')"
                            :class="autocompleteItemsIndex === index ? 'li-autocomplete is-curr' : 'li-autocomplete'">
                          <span>{{ item.first }}<strong class="strong-autocomplete">{{ item.mid }}</strong>{{ item.last }}</span>
                          <br><span class="grayDepartment">{{ item.departsLabel }}</span>
                        </li>
                        <li v-if="autocompleteItems.length === 0"><span
                            class="el-checkbox__label note-association">{{$t("wm_lang_html_ab9ed8")}}</span></li>
                        <li v-if="autocompleteItems.length >= 200"><span
                            class="el-checkbox__label note-association">{{$t("wm_lang_html_5120e6")}}{{autocompleteItems.length}}条匹配，请输入更多信息以缩小范围</span>
                        </li>
                      </ul>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$i18n.t('wm_lang_00237d')" v-show="showBccer">
                    <div class="flexCenter">
                      <div ref="bccDiv" class="tagit-box" @click="focusInputPos('bcc',-1)">
                        <draggable v-model="form.bccLabel" group="rcptLabel" animation="100">
                          <transition-group>
                            <div v-for="(item, index) in form.bccLabel" :key="index" class="addr-div">
                              <div v-if="form.bccInputPos===index" class="tagit-mevt tagit-new addr-div">
                                <input type="text" :ref="`bccInput${index}`" data-ipt="bcc" :style="{width: inputWidth(form.bcc) }"
                                       v-model="form.bcc" @click.stop="stopBubble($event)" @blur="addresseeLabel('bcc')"
                                       @keydown="addrKeydown($event, 'bcc')" @keyup="addrKeyup($event, 'bcc')"
                                       v-on:input="onChangeAutocompleteFilterText" autocomplete="off" class="el-input__inner">
                              </div>
                              <div @click.stop="focusInputPos('bcc', index)" class="addr-div" style="cursor:text;">
                                &nbsp;&nbsp;&nbsp;
                              </div>
                              <div @click.stop="selectLabel(item.org)" @dblclick.stop="editLabel(item, $event)"
                                   :item="item" total="" title="" class="tagit-mevt tagit-choice addr-div"
                                   :class="`${item.org === selectedLabel ? ' selected ' : ''}${isErrorAddress(item) ? ' error ' : ''}${item.org === dblclickLabel && editingLabel ? ' label-editing' : ''}`">
                                <span>{{ item.name }}</span>
                                <input type="text" v-focus v-if="item.org === dblclickLabel && editingLabel"
                                       v-model="currEditLabelVal"
                                       @click.stop="stopBubble($event)"
                                       @focus="editLabelFocus" @blur="addresseeLabelEdit('bcc', index)"
                                       @keyup="addrEditKeyup($event, 'bcc')"
                                       :style="{width: inputWidth(currEditLabelVal) }"/>
                                <span @click="removeRcpts(index, 'bcc')" class="tagit-box-close">x</span>
                              </div>
                            </div>
                          </transition-group>
                        </draggable>
                        <div v-if="form.bccInputPos<0" class="tagit-mevt tagit-new" style="float:left;">
                          <input type="text" ref="bccInput" data-ipt="bcc" v-model="form.bcc"
                                 :style="{width: inputWidth(form.bcc) }"
                                 @click.stop="stopBubble($event)" @blur="addresseeLabel('bcc')"
                                 @keydown="addrKeydown($event, 'bcc')" @keyup="addrKeyup($event, 'bcc')"
                                 v-on:input="onChangeAutocompleteFilterText" autocomplete="off" class="el-input__inner">
                        </div>
                      </div>
                      <div class="addBtnBox">
                        <el-button icon="el-icon-plus" @click="selectContactHandle" tabindex="-1"></el-button>
                      </div>
                    </div>
                    <!-- 检索列表 -->
                    <div v-show="enableAutocompleteBcc && autocompleteItems.length > 0" id="writeMailAutocompleteBcc"
                         ref="writeMailAutocompleteBcc"
                         class="tagit-autocomplete nice_scroll" style="">
                      <ul>
                        <li v-for="(item, index) in autocompleteItems" :key="index" :item="item" @click.prevent="addRcpts(item, 'bcc')"
                            :class="autocompleteItemsIndex === index ? 'li-autocomplete is-curr' : 'li-autocomplete'">
                          <span>{{ item.first }}<strong class="strong-autocomplete">{{ item.mid }}</strong>{{ item.last }}</span>
                          <br><span class="grayDepartment">{{ item.departsLabel }}</span>
                        </li>
                        <li v-if="autocompleteItems.length === 0"><span
                            class="el-checkbox__label note-association">{{$t("wm_lang_html_ab9ed8")}}</span></li>
                        <li v-if="autocompleteItems.length >= 200"><span
                            class="el-checkbox__label note-association">{{$t("wm_lang_html_5120e6")}}{{
                            autocompleteItems.length
                          }}条匹配，请输入更多信息以缩小范围</span>
                        </li>
                      </ul>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$i18n.t('wm_lang_df23a5')" style="margin-bottom:0px;">
                    <el-input v-model="form.subject"></el-input>
                  </el-form-item>
                  <el-form-item label="">
                    <div class="clearfix" style="line-height:24px;margin-top:5px;">
                      <span><el-link type="primary" :underline="false" id="filePicker"><i
                          class="el-icon-paperclip"></i>&nbsp;{{$t("wm_lang_html_4c785f")}}</el-link></span>
                      <el-divider direction="vertical"></el-divider>
                      <span @click="dropUpload = !dropUpload"><el-link type="primary" :underline="false">{{$t("wm_lang_html_5ee6c3")}}</el-link></span>
                      <el-divider v-if="largeAttachPriv" direction="vertical"></el-divider>
                      <span v-if="largeAttachPriv"><el-link type="primary" :underline="false" @click="largeAttachDialog"><i
                          class="el-icon-cloudy"></i>&nbsp;{{$t("wm_lang_html_46042d")}}</el-link></span>
                      <el-divider direction="vertical" v-if="!showBccer"></el-divider>
                      <span><el-link type="primary" v-show="!showBccer" :underline="false"
                                     @click="showBccer = true">{{$t("wm_lang_html_c7bc5c")}}</el-link></span>
                    </div>
                    <!-- 传附件后样式 -->
                    <!--<div id="custom-queue" style="line-height:24px;">-->
                    <!--<p><i class="el-icon-paperclip"></i>&nbsp;{{file.name}} ({{fileSize(file.size)}})<el-link type="primary" :underline="false" class="ml5">[{{$t("wm_lang_html_8b6aed")}}]</el-link><el-link type="primary" :underline="false" class="ml5">[{{$t("wm_lang_html_2f4aad")}}]</el-link></p>-->
                    <!--</div>-->
                    <div class="file-panel nice_scroll">
                      <div class="file-list">
                        <ul class="file-item" :class="`file-${file.id}`" v-for="(file, index) in attachInfos">
                          <li class="file-name">
                            <i class="el-icon-paperclip"></i>
                            &nbsp;{{ file.fileName }}
                            &nbsp;({{ fileSize(file.size) }})
                            <!--<a title=this.$i18n.t('wm_lang_8b6aed') @click="removeAttach(index)">[{{$t("wm_lang_html_8b6aed")}}]</a>-->
                            &nbsp;<a :title="$i18n.t('wm_lang_2f4aad')" @click="removeAttach(index)">[{{$t("wm_lang_html_2f4aad")}}]</a>
                            <span class="file-status"></span>
                            <span class="progress"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="file-panel nice_scroll">
                      <div class="file-list">
                        <ul class="file-item" :class="`file-${file.id}`" v-for="file in fileList">
                          <li class="file-name">
                            <i class="el-icon-paperclip"></i>
                            &nbsp;{{ file.name }}
                            &nbsp;({{ fileSize(file.size) }})
                            <!--<a title=this.$i18n.t('wm_lang_8b6aed') @click="removeFile(file)">[{{$t("wm_lang_html_8b6aed")}}]</a>-->
                            <i class="el-icon-loading"></i>
                            <a class="cancel-file-upload" style="display: none" :title="$i18n.t('wm_lang_457406')" @click="cancelFile(file)">[{{$t("wm_lang_html_457406")}}]</a>
                            <a class="remove-file-upload" style="display: none" :title="$i18n.t('wm_lang_2f4aad')" @click="removeFile(file)">[{{$t("wm_lang_html_2f4aad")}}]</a>
                            <span class="file-status"></span>
                            <span class="progress"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <vue-upload
                        ref="uploader"
                        uploadButton="#filePicker"
                        multiple
                        @openLargeAttach="openLargeAttach"
                        @fileChange="fileChange"
                        @uploadError="uploadError"
                        @progress="onProgress"
                        @success="onSuccess"
                    ></vue-upload>
                    <vue-upload-large
                        ref="uploaderLarge"
                        uploadButton="#largeFilePicker"
                        multiple
                        @fileChange="fileChange"
                        @uploadError="uploadError"
                        @progress="onProgress"
                        @success="onSuccessLarge"
                    ></vue-upload-large>
                  </el-form-item>
                </el-form>
              </div>
              <div class="encryption" v-show="cancelPassword">
                <div class="lable">{{$t("comm_lang_0025")}}：</div>
                <div class="text">
                  <span v-show="showPassword">{{mailPassword}}</span><span v-show="!showPassword" @click="showMailPw">{{$t("comm_lang_0055")}}</span><span  v-show="showPassword" @click="hideMailPw">{{$t("comm_lang_0056")}}</span>|<span @click="cancelMailPw">{{$t("comm_lang_0057")}}</span>
                </div>
              </div>
              <div class="writemailcontent" @dragover="fileDragover">
                <tinymce-editor ref="editor"
                                v-model="editorContent"
                                @onClick="onClick">
                </tinymce-editor>
                <div id="dropUploadWrap" class="dropUploadMask" v-show="dropUpload" @click="dropUpload = !dropUpload"><p>
                  {{$t("custom_lang_0029")}}</p></div>
              </div>
              <div class="writemailbottom flexBetween f12">
                <div class="left">
                  <span>{{$t("wm_lang_html_2df6a3")}}</span>
                  <el-dropdown size="small" @command="setSenderCommand">
                      <span class="el-dropdown-link f12">
                        <span><strong
                            class="mr5 max197 cutout ib pr-1">{{ localUserInfo.userName }}</strong><em>&lt;{{ getMailFrom }}&gt;</em></span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="item" :icon="mailFrom === item ? 'el-icon-check':''"
                                        :class="mailFrom === item ? 'active':''" v-for="(item, index) in senderList" :key="index">
                        <i class="zw">&nbsp;</i>{{ item }}
                      </el-dropdown-item>
                      <el-dropdown-item divided command="setSender">{{$t("wm_lang_html_f83e6b")}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown size="small" @command="setSignCommand">
                      <span class="el-dropdown-link f12">
                        <span>{{$t("wm_lang_html_be2525")}}</span><i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-zw-true">
                      <el-dropdown-item command="notUse" :icon="signNotUse ? 'el-icon-check' : ''" :class="signNotUse ? 'active' : ''">
                        <i class="zw">&nbsp;</i>{{$t("custom_lang_0053")}}
                      </el-dropdown-item>
                      <el-dropdown-item :command="item.signId" :icon="item.signId === signIdCurr ? 'el-icon-check' : ''"
                                        :class="item.signId === signIdCurr ? 'active' : ''" v-for="(item, index) in persSignList"
                                        :key="index"><i class="zw">&nbsp;</i>{{ item.name }}
                      </el-dropdown-item>
                      <!--<el-dropdown-item icon="el-icon-check" class="active">{{$t("wm_lang_html_411fee")}}</el-dropdown-item>-->
                      <el-dropdown-item command="setSign" divided><i class="zw">&nbsp;</i>{{$t("wm_lang_html_cbfcf6")}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-dropdown size="small">
                      <span class="el-dropdown-link f12">
                        <span>{{$t("wm_lang_html_6ffab1")}}</span><i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                    <el-dropdown-menu slot="dropdown">
                      <!--<el-checkbox-group v-model="checkList" class="p10-p20">-->
                      <!--<el-checkbox label=this.$i18n.t('wm_lang_b2352a')></el-checkbox>-->
                      <!--<el-checkbox label=this.$i18n.t('wm_lang_63e0ca')></el-checkbox>-->
                      <!--<el-checkbox label=this.$i18n.t('wm_lang_cb0ed5')></el-checkbox>-->
                      <!--<el-checkbox label=this.$i18n.t('wm_lang_74e5c0')></el-checkbox>-->
                      <!--</el-checkbox-group>-->
                      <div class="p10-p20">
                        <el-checkbox v-model="sendOtherOption.saveToSent"><span class="title">{{$t("wm_lang_html_b2352a")}}</span></el-checkbox>
                        <el-checkbox v-model="sendOtherOption.receipt"><span class="title">{{$t("wm_lang_html_63e0ca")}}</span></el-checkbox>
                        <el-checkbox v-model="sendOtherOption.urgent"><span class="title">{{$t("wm_lang_html_cb0ed5")}}</span></el-checkbox>
                        <el-checkbox v-if="sendAlonePriv" v-model="sendOtherOption.sendAlone"><span v-if="sendAlonePriv" class="title">{{$t("wm_lang_html_2bf9a9")}}</span></el-checkbox>
                        <el-checkbox @change="timingChange" v-model="sendOtherOption.timing"><span class="title">{{$t("wm_lang_html_74e5c0")}}</span></el-checkbox>
                        <el-checkbox @change="encryptChange" v-model="sendOtherOption.encryptMail"><span class="title">{{$t("comm_lang_0025")}}</span></el-checkbox>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="center mal mr10" v-show="sendOtherOption.timing">
                  <el-date-picker
                  v-model="sendOtherOption.mtaTime"
                  size="mini"
                  type="datetime"
                  style="width:175px;"
                  value-format="timestamp"
                  :placeholder="$i18n.t('wm_lang_8e97c5')">
                  </el-date-picker>
                </div>
                <div class="right">
                  <span><el-link type="primary" :underline="false" style="font-size:12px;" @click="goSetFont">{{$t("wm_lang_html_0c71d6")}}</el-link></span>
                </div>
              </div>
              <!-- 添加超大附件 -->
              <el-dialog
                  :title="$i18n.t('wm_lang_f7c30e')"
                  :visible.sync="dialogAttachVisible"
                  :close-on-click-modal="false"
                  width="600px">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                  <el-tab-pane :label="$i18n.t('wm_lang_8d90d2')" name="first">
                    <div class="fj_box">
                      <h4 class="c_blue">{{$t("wm_lang_html_e5ff1a")}}</h4>
                      <el-collapse v-model="activeName1" accordion>
                        <!-- <el-collapse-item title=this.$i18n.t('wm_lang_67bc37')+"-"+this.$i18n.t('wm_lang_a12b8a') name="1">
                          <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
                        </el-collapse-item>
                        <el-collapse-item title=this.$i18n.t('wm_lang_67bc37')+"-"+this.$i18n.t('wm_lang_38e3ff') name="2">
                          <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
                        </el-collapse-item> -->
                        <el-collapse-item :title="$i18n.t('wm_lang_46042d')" name="3">
                          <ul class="largeAttach-list">
                            <li
                                v-if="item"
                                :class="selectedLargeAttach.includes(item) ? 'selected' : ''"
                                v-for="(item, index) in largeAttachData"
                                @click="selectLargeAttachClick(item)"
                            >{{ item.name }} {{ getCreateDate(item.expireDate) }}
                            </li>
                          </ul>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="$i18n.t('wm_lang_65f627')" name="second">
                    <div class="fj_box">
                      <!--<div class="state flexBetween f12 warning">-->
                      <!--<span>{{$t("wm_lang_html_3d2a2f")}}</span>-->
                      <!--<el-button size="mini"><i class="el-icon-download">{{$t("wm_lang_html_deb009")}}</i></el-button>-->
                      <!--</div>-->
                      <h4 class="c_blue">{{$t("wm_lang_html_fb8f3d")}}</h4>
                      <div class="mb15">
                        <el-radio v-model="radio" label="1" class="mb5">{{$t("wm_lang_html_b960ee")}} --
                          {{$t("custom_lang_0047")}}{{ largeAttachExpireTime }}{{$t("wm_lang_249aba")}}<span>({{$t("wm_lang_html_d88651")}}{{ maxLargeAttachSize }})</span></el-radio>
                        <!--<el-radio v-model="radio" label="2" class="mb5">{{$t("wm_lang_html_4a5c68")}} &#45;&#45; {{$t("wm_lang_html_dfe170")}}<span>({{$t("wm_lang_html_d88651")}}1.88TB)</span></el-radio>-->
                      </div>
                      <!--<el-collapse v-model="activeName1" accordion>-->
                      <!--<el-collapse-item title=this.$i18n.t('wm_lang_67bc37')+"-"+this.$i18n.t('wm_lang_a12b8a') name="1">-->
                      <!--<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>-->
                      <!--</el-collapse-item>-->
                      <!--<el-collapse-item title=this.$i18n.t('wm_lang_67bc37')+"-"+this.$i18n.t('wm_lang_38e3ff') name="2">-->
                      <!--<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>-->
                      <!--</el-collapse-item>-->
                      <!--<el-collapse-item title=this.$i18n.t('wm_lang_46042d') name="3">-->
                      <!--<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>-->
                      <!--</el-collapse-item>-->
                      <!--</el-collapse>-->
                    </div>
                  </el-tab-pane>
                </el-tabs>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogAttachVisible = false">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
                  <el-button type="primary" v-show="activeName === 'first'" @click="addToMail">{{$t("wm_lang_html_bbdb15")}}</el-button>
                  <span v-show="activeName === 'second'" id="largeFilePicker">{{$t("wm_lang_html_8d0cfb")}}...</span>
                </span>
              </el-dialog>
              <!-- 从联系人中选择 -->
              <!--<el-dialog-->
              <!--title=this.$i18n.t('wm_lang_cda4d5')-->
              <!--:visible.sync="dialogAddress"-->
              <!--width="50%">-->
              <!--<div class="alertWinBox">-->
              <!--<el-row>-->
              <!--<el-col :span="11">-->
              <!--<div class="left">-->
              <!--<el-input placeholder=this.$i18n.t('wm_lang_d28df0')+"..." v-model="inputSearch" size="small">-->
              <!--<el-button slot="append" icon="el-icon-search" style="padding:12px;"></el-button>-->
              <!--</el-input>-->
              <!--<div class="mt10">-->
              <!--<el-tabs type="border-card">-->
              <!--<el-tab-pane label=this.$i18n.t('wm_lang_d43e13')>-->
              <!--<el-tree-->
              <!--:data="data"-->
              <!--show-checkbox-->
              <!--node-key="id"-->
              <!--:default-expanded-keys="[2, 3]"-->
              <!--:default-checked-keys="[5]"-->
              <!--:props="defaultProps">-->
              <!--</el-tree>-->
              <!--</el-tab-pane>-->
              <!--<el-tab-pane label=this.$i18n.t('wm_lang_d3298c')>-->

              <!--</el-tab-pane>-->
              <!--</el-tabs>-->
              <!--</div>-->
              <!--</div>-->
              <!--</el-col>-->
              <!--<el-col :span="2">-->
              <!--<div class="center">-->
              <!--<el-link type="primary" :underline="false" title=this.$i18n.t('wm_lang_fb5bf1')><i class="el-icon-d-arrow-right"></i></el-link>-->
              <!--<el-link type="primary" :underline="false" title=this.$i18n.t('wm_lang_24969a')><i class="el-icon-d-arrow-right"></i></el-link>-->
              <!--<el-link type="primary" :underline="false" title=this.$i18n.t('wm_lang_76ea0d')><i class="el-icon-d-arrow-right"></i></el-link>-->
              <!--</div>-->
              <!--</el-col>-->
              <!--<el-col :span="11">-->
              <!--<div class="right">-->
              <!--<el-collapse v-model="activeRightName" @change="handleChange">-->
              <!--<el-collapse-item name="1">-->
              <!--<template slot="title">-->
              <!--收件人<span id="maxNumDom">(<span class="maxNumTip" id="maxNumTip">0</span>/1000)</span><i class="header-icon el-icon-delete ml10"></i>-->
              <!--</template>-->
              <!--<div>-->
              <!--<ul class="selected_to nice_scroll">-->
              <!--<li class="del">{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--</ul>-->
              <!--</div>-->
              <!--</el-collapse-item>-->
              <!--<el-collapse-item title=this.$i18n.t('wm_lang_24969a') name="2">-->
              <!--<div>-->
              <!--<ul class="selected_to nice_scroll">-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--</ul>-->
              <!--</div>-->
              <!--</el-collapse-item>-->
              <!--<el-collapse-item title=this.$i18n.t('wm_lang_76ea0d') name="3">-->
              <!--<div>-->
              <!--<ul class="selected_to nice_scroll">-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--<li>{{$t("wm_lang_html_615db5")}} [san.zhang@net263.com]</li>-->
              <!--</ul>-->
              <!--</div>-->
              <!--</el-collapse-item>-->
              <!--</el-collapse>-->
              <!--</div>-->
              <!--</el-col>-->
              <!--</el-row>-->
              <!--</div>-->
              <!--<span slot="footer" class="dialog-footer">-->
              <!--<el-button @click="dialogAddress = false">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>-->
              <!--<el-button type="primary" @click="dialogAddress = false">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>-->
              <!--</span>-->
              <!--</el-dialog>-->
              <!--<SelectContactDialog v-model="selectContactVisible" :getOrgTrees="getOrgTrees" :getPersTrees="getPersTrees" :getMailContact="getMailContact" :cancelSelectContact="cancelSelectContact" />-->
              <SelectContactDialog ref="selectContactDialog" v-model="selectContactVisible" :getOrgTrees="getOrgTrees"
                                   :getPersTrees="getPersTrees" :getMailContact="getMailContact"
                                   :cancelSelectContact="cancelSelectContact"/>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :title="$i18n.t('comm_lang_0025')" width="500px" :visible.sync="encryptFormVisible" :close-on-click-modal="false">
        <div style="color: #cccccc; font-size: 12px; margin:5px 0px 20px;">{{$t("comm_lang_0052")}}</div>
        <el-form label-width="90px" :model="encryptForm">
          <el-form-item :label="$i18n.t('comm_lang_0053')" class="enitemsForm">
            <el-input type="password" v-model="encryptForm.pw" :placeholder="$i18n.t('comm_lang_0060')" style="width: 320px" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$i18n.t('comm_lang_0054')" class="enitemsForm">
            <el-input type="password" v-model="encryptForm.cpw" :placeholder="$i18n.t('wm_lang_a24ab0')" style="width: 320px" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="encryptFormCancel">{{$t("wm_lang_html_625fb2")}}</el-button>
          <el-button type="primary" @click="encryptFormConfirm">{{$t("wm_lang_html_38cf16")}}</el-button>
        </div>
      </el-dialog>
      <!-- 右侧页签 -->
      <!--<tabBar></tabBar>-->
    </div>
    <!--<app-footer></app-footer>-->
  </el-container>
  <!--</el-container>-->
  <!--</div>-->
  <!--</el-container>-->
  <!--</div>-->
</template>

<script>
import AppHeader from '@/components/sub/Header.vue'
import AppFooter from '@/components/sub/Footer.vue'
import asideSet from '@/components/sub/asideSet.vue'
import setBreadNav from '@/components/sub/setBreadNav.vue'
import listBar from '@/components/sub/listBar.vue'
import tabBar from '@/components/sub/tabBar.vue'
import setComponent from "@/components/views/setBox/setComponent"
import boxMail from "@/components/views/layout/boxMail"
import TinymceEditor from '@/components/views/editor/tinymce-editor'
import {isEmail} from '@/utils/validate';
import {bitIs1, belongRootFolderId} from '@/utils/utils';
import xmail from '@/api/api';
import $ from 'jquery';
import WebUploader from 'webuploader';
import vueUpload from '@/components/sub/upload';
import vueUploadLarge from '@/components/sub/uploadLarge';
import md5 from 'js-md5';
import storeLocal from 'store';
import SelectContactDialog from '../../sub/selectContactDialog.vue';
import BaseAutocomplete from "../../views/member_selector/BaseAutocomplete";
import _ from "lodash";
import TreeUtil from "../../core/tree/TreeUtil";
import {invalid} from "moment";
import emailUtil from "../../core/common/EmailUtil";
import draggable from "vuedraggable";
import moment from "moment/moment";
import {sendMailErrorAlert} from '@/utils/sendMailAlert';

export default {
    // name: 'layoutWriteMail',
    name: 'WriteMail',
    mixins: [BaseAutocomplete],
    data() {
        return {
            msgindex: this.$i18n.t('wm_lang_4076f9'),
            user: 'dcz05@xw002.net',
            form: {
                receiver: '',
                receiverLabel: [],
                recInputPos: -1,
                // receiverErrorLabel: [],
                cc: '',
                ccLabel: [],
                ccInputPos: -1,
                // ccErrorLabel: [],
                bcc: '',
                bccLabel: [],
                bccInputPos: -1,
                // bccErrorLabel: [],
                subject: ''
            },
            addrEmptyFlag: {
                rec: true,
                cc: true,
                bcc: true
            },
            sendOtherOption: {
                saveToSent: false,
                receipt: false,
                urgent: 0,
                sendAlone: false,
                timing: false,
                mtaTime: '',
                encryptMail: false
            },
            timingMailFlag: false,//再次编辑时后端接口需要知道当前信是否为定时发送的信
            encryptForm: {
                pw: '',
                cpw: ''
            },
            encryptFormVisible:false,
            senderList: [],
            mailFrom: '',
            persSignList: [],
            localUserInfo: '',
            localConfigSetting: '',
            sendAlonePriv: false,
            largeAttachPriv: false,
            orgTrees: [],
            persTrees: [],
            selectContactVisible: false,
            dropUpload: false,
            fileList: [],
            innerFileInfos: [],//（暂不用）编辑器内嵌图标，暂定用编辑器默认的base64方案
            attachInfos: [],
            attachUploadingRecords: [], // 记录正在上传文件ID
            chunkSize: 2048000,
            editingLabel: false,
            currEditLabelVal: '',
            dblclickLabel: '',
            selectedLabel: '',
            editorContent: '',
            editorSign: '',
            signIdCurr: '',
            signNotUse: false,
            showBccer: false,
            checkList: [this.$i18n.t('wm_lang_b2352a')],
            dialogAttachVisible: false,
            dialogAddress: false,
            activeName: 'first',
            activeName1: '3',
            activeRightName: ['1', '2', '3'],
            largeAttachData: [],
            selectedLargeAttach: [],
            subjectFw: 'Fw:',
            subjectRe: 'Re:',
            subjectAutoRe: 'Auto-Re:',
            replyWithContent: true,
            maxLargeAttachSize: '0',
            largeAttachExpireTime: 0,
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            radio: '1',
            inputSearch: '',
            autocompleteItemsIndex: 0,
            currentDraftMailIndexId: '',
            sendType: '',
            sendTypeDISABLE: 0,
            maxAttachSizeSingle: 0,
            maxToNumSingle: 0,
            draftTimer: null,
            invalidAddresses: [],
            editorInitDom: '',
            cancelPassword: false,
            mailPassword: '',
            showPassword: false
        }
    },
    components: {
        // Home,
        // inBox,
        setComponent,
        // writeBox,
        // actionBar,
        asideSet,
        setBreadNav,
        tabBar,
        listBar,
        'app-header': AppHeader,
        'app-footer': AppFooter,
        // 'app-aside': AppAside,
        boxMail,
        TinymceEditor,
        SelectContactDialog,
        vueUpload,
        vueUploadLarge,
        draggable
    },
    computed: {
        uploader() {
            return this.$refs.uploader;
        },
        uploaderLarge() {
            return this.$refs.uploaderLarge;
        },
        inputWidth() {
            return function (value) {
                if (!value || (value.length <= 20)) {
                    return '140px'
                } else {
                    return (String(value).length * 6 + 30) + 'px'
                }
            }
        },
        getMailFrom() {
            return this.mailFrom ? this.mailFrom : this.localUserInfo.userEmail;
        },
        frontReceiverLabel() {
            if (this.form.recInputPos < 0) {
                return this.form.receiverLabel;
            }
            if (this.form.recInputPos > 0 && this.form.recInputPos < this.form.receiverLabel.length) {
                return this.form.receiverLabel.slice(0, this.form.recInputPos);
            }
            return [];
        },
        behindReceiverLabel() {
            if (this.form.recInputPos < 0 || this.form.recInputPos >= this.form.receiverLabel.length) {
                return [];
            }
            return this.form.receiverLabel.slice(this.form.recInputPos);
        },
        formItemClass() {
            return item => {
                return {
                    selected: item.org === this.selectedLabel,
                    error: this.isErrorAddress(item),
                    'label-editing': item.org === this.dblclickLabel,
                };
            };
        }
    },
    watch: {
        $route(to, from) {
            // console.log(to);
            // console.log(from);
        }
    },
    mounted() {
        // console.log('----------write mounted-----------');
        //全局点击隐藏地址栏联想
        this.$globalClick(() => {
            // this.form.receiver = '';
            // this.form.cc = '';
            // this.form.bcc = '';
            if (this.enableAutocompleteRec) {
                this.addresseeLabel('rec');
            }
            if (this.enableAutocompleteCc) {
                this.addresseeLabel('cc');
            }
            if (this.enableAutocompleteBcc) {
                this.addresseeLabel('bcc');
            }
        }, 'indexBox', ['writeMailAutocompleteRec', 'writeMailAutocompleteCc', 'writeMailAutocompleteBcc']);
        // console.log(this.$route)
        this.localUserInfo = storeLocal.get('Pwm-userInfo');
        this.localConfigSetting = storeLocal.get('Pwm-configSetting');
        this.senderList = [this.localUserInfo.userEmail]; //模拟数据，登录接口提供
        this.mailFrom = this.localUserInfo.userEmail;
        if (this.localUserInfo.userEmail !== this.localUserInfo.primeUserEmail) {
            this.senderList.push(this.localUserInfo.primeUserEmail);
        }
        this.sendOtherOption.receipt = this.localConfigSetting.deliverSetting.receipt;
        this.sendOtherOption.saveToSent = this.localConfigSetting.deliverSetting.webSent;
        this.replyWithContent = this.localConfigSetting.deliverSetting.replyWithContent;
        this.largeAttachExpireTime = this.localConfigSetting.deliverSetting.largeAttachExpireTime;
        this.sendType = this.localConfigSetting.deliverSetting.sendType;
        this.maxAttachSizeSingle = this.localConfigSetting.deliverSetting.maxAttachSizeSingle;
        this.maxToNumSingle = this.localConfigSetting.deliverSetting.maxToNumSingle;
        this.sendTypeDISABLE = xmail.enums.RoleDeliverSendType.DISABLE;
        // 群发单显权限处理
        this.sendAlonePriv = bitIs1(this.localConfigSetting.priviage.priviage1, 4);
        // 超大附件权限处理
        this.largeAttachPriv = bitIs1(this.localConfigSetting.priviage.priviage1, 6);
        //匹配主题头格式
        if (this.localConfigSetting.deliverSetting.replySubjectPrefix === xmail.enums.ReplySubjectPrefix.CN) {
            this.subjectFw = this.$i18n.t('wm_lang_21e106')+':';
            this.subjectRe = this.$i18n.t('wm_lang_1edff0')+':';
            this.subjectAutoRe = this.$i18n.t('wm_lang_922a77')+':';
        }
        this.editorInitDom = '<p style="font-family: '+ this.localConfigSetting.deliverSetting.fontName +'; font-size: '+ this.localConfigSetting.deliverSetting.fontSize +'px"></p>'
                            + '<p style="font-family: '+ this.localConfigSetting.deliverSetting.fontName +'; font-size: '+ this.localConfigSetting.deliverSetting.fontSize +'px"></p>'
                            + '<p style="font-family: '+ this.localConfigSetting.deliverSetting.fontName +'; font-size: '+ this.localConfigSetting.deliverSetting.fontSize +'px"></p>'
                            + '<p style="font-family: '+ this.localConfigSetting.deliverSetting.fontName +'; font-size: '+ this.localConfigSetting.deliverSetting.fontSize +'px"></p>'
                            + '<p style="font-family: '+ this.localConfigSetting.deliverSetting.fontName +'; font-size: '+ this.localConfigSetting.deliverSetting.fontSize +'px"></p>';
        let self = this;
        self.getSignList();
        //定时保存草稿
        // setTimeout(() => {
        //   self.setWriteDataStore();
        // }, 2000);
        clearInterval(this.draftTimer);
        this.draftTimer = setInterval(() => {
            // console.log(this.$route.name);
            if (this.$route.name === 'write') {
                self.timgSaveDraft();
            }
        }, 1000 * 60 * 2);
        this.$EventBus.$off("getDraftDataMd5");
        this.$EventBus.$on("getDraftDataMd5", function (data) {
            // console.log(data)
            // let edCont = tinymce.get('tinymceEditor').getContent();
            // let dataSet = self.writeDataSet(edCont);
            // console.log(dataSet);
            self.closeDraftDataMd5();
        });
        this.$EventBus.$off("changeTabDraftSave");
        this.$EventBus.$on("changeTabDraftSave", function (data) {
            // console.log(data)
            self.changeTabDraftSave();
        });
        this.$EventBus.$off("dialogSaveDraft");
        this.$EventBus.$on("dialogSaveDraft", function (data) {
            self.draftMail();
        });
        this.$EventBus.$off("againInitWrite");
        this.$EventBus.$on("againInitWrite", function (data) {
            let edCont = tinymce.get('tinymceEditor').getContent();
            let dataSet = self.writeDataSet(edCont);
            // console.log(md5(JSON.stringify(dataSet)) !== self.$store.getters.writeDataMd5);
            if (md5(JSON.stringify(dataSet)) !== self.$store.getters.writeDataMd5) {
                self.$confirm(self.$i18n.t('wm_lang_f7a9dd')+','+self.$i18n.t('wm_lang_b1c5ea'), self.$i18n.t('wm_lang_c45357'), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: self.$i18n.t('wm_lang_38cf16'),
                    cancelButtonText: self.$i18n.t('wm_lang_625fb2'),
                    closeOnClickModal: false,
                    type: 'warning'
                }).then(() => {
                    self.draftMail();
                    self.replyAddData({}, 'write');
                    self.$message({
                      type: 'success',
                      message: self.$i18n.t('wm_lang_318305')
                    });
                    setTimeout(() => {
                        self.appendSignature(self);
                        self.currentDraftMailIndexId = '';
                    }, 500);
                }).catch(action => {
                    //
                });
            } else {
                self.replyAddData({}, 'write');
                setTimeout(() => {
                    self.appendSignature(self);
                    self.currentDraftMailIndexId = '';
                }, 500);
            }
            self.timingMailFlag = false;
        });
    },
    activated() {
        let mailData = this.$store.getters.mailData;
        console.log('--------------------------boxWrite activated----------------------------');
        console.log(this.$route);
        // let writeType = this.$route.params ? this.$route.params : 'write';
        // let writeType = this.$route.params ? this.$route.params.type : 'write';
        if (this.$route.params.type) {
            this.$store.commit('SET_WRITE_TYPE', this.$route.params.type);
        }

        if (this.$store.getters.currWriteType === 'draft') {
            // console.log(this.$store.getters.mailData);
            // this.currentDraftMailIndexId = this.$store.getters.mailData ? this.$store.getters.mailData.mailIndexId : '';
            // console.log(this.$route.params.mid);
            this.currentDraftMailIndexId = this.$route.params.mid;
        }

        if (!this.$route.params.tabRoute) { //排除点击页签切换到写信路由的情况
            // console.log(this.currWriteType);
            // console.log(mailData);
            let currWriteType = this.$store.getters.currWriteType;
            // console.log(currWriteType);
            switch (currWriteType) {
                case 'write':
                    this.replyAddData(mailData, 'write');
                    break;
                case 'forward':
                    this.replyAddData(mailData, 'forward');
                    break;
                case 'forwardMultiple':
                    if (mailData !== null) {
                        this.replyAddData(mailData, 'forwardMultiple');
                    } else {
                        let allMailsOne = this.$store.getters.checkedMails[0];
                        //未点击邮件读信直接点击全选操作
                        let self = this;
                        (function (api, enums, pms) {
                            let mId = allMailsOne.mailIndexId;
                            let fileId = allMailsOne.fileId;
                            let mailRead = allMailsOne.seen;
                            let rpm = pms.MailFile.getMailInfoParamBuilder();
                            rpm.mailIndexId = mId;
                            rpm.fileId = fileId;
                            rpm.mailStatus = enums.MailStatus.UNREAD
                            if (mailRead === true) {
                                rpm.mailStatus = enums.MailStatus.READ
                            }
                            // 获取邮件
                            api.MailFile.getMailInfo(rpm, function (res) {
                                // console.log(res.data)
                                if (res.data.code === 0) {
                                    let mailData = res.data.data.mailInfo;
                                    self.replyAddData(mailData, 'forwardMultiple');
                                }
                            })
                        })(xmail.api, xmail.enums, xmail.pms);
                    }
                    break;
                case 'forwardTbSingle':
                    let mailDataTbSingle = this.$store.getters.checkedMails[0];
                    //列表布局下勾选一封时不读信，索引数据没有附件信息，需要调读信接口取
                    let self = this;
                    (function (api, enums, pms) {
                        let mId = mailDataTbSingle.mailIndexId;
                        // let mId = this.mailId;
                        // let fId = self.$store.state.folder.folderId;
                        let fileId = mailDataTbSingle.fileId;
                        let mailRead = mailDataTbSingle.seen;
                        let rpm = pms.MailFile.getMailInfoParamBuilder();
                        rpm.mailIndexId = mId;
                        rpm.fileId = fileId;
                        rpm.mailStatus = enums.MailStatus.UNREAD
                        if (mailRead === true) {
                            rpm.mailStatus = enums.MailStatus.READ
                        }
                        // 获取邮件
                        api.MailFile.getMailInfo(rpm, function (res) {
                            // console.log(res.data)
                            if (res.data.code === 0) {
                                let mailData = res.data.data.mailInfo;
                                self.replyAddData(mailData, 'forwardTbSingle');
                            }
                        })
                    })(xmail.api, xmail.enums, xmail.pms);
                    break;
                case 'reply':
                    // console.log(mailData)
                    this.replyAddData(mailData, 'reply');
                    break;
                case 'replyAll':
                    this.replyAddData(mailData, 'replyAll');
                    break;
                case 'replyAllAttach':
                    this.replyAddData(mailData, 'replyAllAttach');
                    break;
                case 'draft':
                    this.editAgainData(mailData, 'draft');
                    break;
                case 'sent':
                    this.editAgainData(mailData, 'sent');
                    break;
                default:
                    return;
            }
        }
    },
    deactivated() {
        // if(this.$route.name !== 'sent') {
        //   console.log(tinymce.get('tinymceEditor'));
        //   let edCont = tinymce.get('tinymceEditor').getContent();
        //   this.changeTabDraftSave(edCont);
        // }
    },
    beforeDestroy() {
        clearInterval(this.draftTimer);
    },
    directives: {
        focus: {
            inserted: (el) => {
                el.focus();
            }
        }
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleNodeClick(data) {
            console.log(data);
        },
        stopBubble(e) {
            e.stopPropagation();
        },
        isTimingMail(attrFlag) {
            return (attrFlag & xmail.flags.MailIndexAttrFlag.SENDLATER_VAL) !== 0
        },
      timingChange() {
            if(this.sendOtherOption.timing) {
                this.sendOtherOption.mtaTime = new Date().getTime()
            } else {
                this.sendOtherOption.mtaTime = ''
            }
        },
        encryptChange() {
            this.encryptFormVisible = this.sendOtherOption.encryptMail;
            if(!this.sendOtherOption.encryptMail) {
                this.encryptForm.pw = '';
                this.encryptForm.cpw = '';
                this.cancelPassword = false;
                this.showPassword = false;
            }
        },
        encryptFormCancel() {
            this.encryptFormVisible = false;
            this.sendOtherOption.encryptMail = false;
            this.encryptForm.pw = '';
            this.encryptForm.cpw = '';
            this.showPassword = false;
        },
        encryptFormConfirm() {
            if(this.encryptForm.pw === '') {
                this.$message({
                  type: 'warning',
                  message: this.$i18n.t('custom_lang_0001')
                });
                return;
            }
            if(this.encryptForm.pw.length > 20) {
                this.$message({
                  type: 'warning',
                  message: this.$i18n.t('custom_lang_0031')
                });
                return;
            }
            let checkSpace = new RegExp(/\s+/g);
            if (checkSpace.test(this.encryptForm.pw)) {
                this.$message({
                  type: 'warning',
                  message: this.$i18n.t('custom_lang_0048')
                });
                return;
            }
            if(this.encryptForm.pw !== this.encryptForm.cpw) {
                this.$message({
                  type: 'warning',
                  message: this.$i18n.t('custom_lang_0002')
                });
                return;
            }
            this.encryptFormVisible = false;
            this.mailPassword = this.encryptForm.pw;
            this.cancelPassword = true;
        },
        showMailPw() {
            this.showPassword = true;
        },
        hideMailPw() {
            this.showPassword = false;
        },
        cancelMailPw() {
            this.sendOtherOption.encryptMail = false;
            this.cancelPassword = false;
            this.encryptForm.pw = '';
            this.encryptForm.cpw = '';
            this.showPassword = false;
        },
        getSignList() {
            let self = this;
            (function (api, enums, pms) {
                api.Sign.queryAllMailAccountSign({}, function (res) {
                    // console.log(res.data.data);
                    if (res.data.code === 0) {
                        self.persSignList = res.data.data;
                    }
                    self.getSignature('init');
                    // self.setWriteDataStore();
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        writeDataSet(edCont) {
            return {
                receiverArr: this.getAddressees('rec'),
                ccArr: this.getAddressees('cc'),
                bccArr: this.getAddressees('bcc'),
                subject: this.form.subject,
                text: edCont,
                // text: this.editorContent.replace(/[\r\n]/g, "").replace(/<div id="personalSignatureWrap">[\s\S]*[\s\S]<\/div>/g,
                // '<div id="personalSignatureWrap"><\/div>').replace(/<div class="write-custom-wrap" [\s\S]*?>/g, ""),
                attachInfos: this.attachInfos,
                saveSend: this.sendOtherOption.saveToSent,
                needReceipt: this.sendOtherOption.receipt,
                priority: this.sendOtherOption.urgent,
                sendAlone: this.sendOtherOption.sendAlone,
                signature: this.editorSign
            }
        },
        setWriteDataStore() {
            if(!tinymce.get('tinymceEditor')) {
              return;
            }
            let edCont = tinymce.get('tinymceEditor').getContent();
            let dataSet = this.writeDataSet(edCont);
            this.$store.commit('SET_WRITEDATA_MD5', md5(JSON.stringify(dataSet)));
            // console.log(this.$store.getters.writeDataMd5);
            // console.log(dataSet);
        },
        timgSaveDraft() {
            let edCont = tinymce.get('tinymceEditor').getContent();
            let dataSet = this.writeDataSet(edCont);
            // console.log(this.$store.getters.writeDataMd5);
            // console.log(dataSet);
            // console.log(md5(JSON.stringify(dataSet)));
            if (md5(JSON.stringify(dataSet)) !== this.$store.getters.writeDataMd5) {
                this.draftMail();
            }
        },
        closeDraftDataMd5() {
            if (this.$route.name !== 'write') {
                this.$store.commit('SET_CURRDRAFTDATA_CHANGE', false);
                return;
            }
            let edCont = tinymce.get('tinymceEditor').getContent();
            let dataSet = this.writeDataSet(edCont);
            // console.log(dataSet);
            // console.log(md5(JSON.stringify(dataSet)));
            // console.log(this.$store.getters.writeDataMd5);
            this.$store.commit('SET_CURRDRAFTDATA_CHANGE', md5(JSON.stringify(dataSet)) !== this.$store.getters.writeDataMd5);
        },
        changeTabDraftSave() {
            let ed = tinymce.get('tinymceEditor');
            if (ed) {
                let edCont = ed.getContent();
                let dataSet = this.writeDataSet(edCont);
                // console.log(dataSet);
                if (md5(JSON.stringify(dataSet)) !== this.$store.getters.writeDataMd5) {
                    this.draftMail()
                }
            }
        },
        tagitBoxFocus(tag) {
            switch (tag) {
                case 'rec':
                    this.$refs.recInput.focus();
                    break;
                case 'cc':
                    this.$refs.ccInput.focus();
                    break;
                case 'bcc':
                    this.$refs.bccInput.focus();
                    break;
            }
        },
        selectContactHandle() {
            this.selectContactVisible = true;
            this.$refs.selectContactDialog.selectContactUpdate(this.form.receiverLabel, this.form.ccLabel, this.form.bccLabel,);
        },
        selectLargeAttachClick(data) {
            if (this.selectedLargeAttach.includes(data)) {
                this.selectedLargeAttach.some((item, index) => {
                    console.log(item.mailAccountFileId)
                    if (item.mailAccountFileId === data.mailAccountFileId) {
                        this.selectedLargeAttach.splice(index, 1);
                    }
                })
            } else {
                this.selectedLargeAttach.push(data);
            }
        },
        addToMail() {
            let opt = {listAdd: true, largeAttachs: this.selectedLargeAttach};
            if (opt.largeAttachs.length <= 0) {
                this.$message({
                    type: 'warning',
                    message: this.$i18n.t('wm_lang_64a156')
                });
                return;
            }
            this.onSuccessLarge(undefined, {}, opt);
        },
        largeFileSize(size) {
            if (size < 1024 * 1024) {
                return (size / (1024)).toFixed(2) + " KB";
            } else if (size < 1024 * 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + " MB";
            } else {
                return (size / (1024 * 1024 * 1024)).toFixed(2) + " G";
            }
        },
        largeAttachDialog() {
            this.dialogAttachVisible = true;
            let self = this;
            (function (api, enums, pms) {
                api.LargeFile.getSpaceInfo({}, function (res) {
                    // console.log(res.data.data)
                    if (res.data.code === 0) {
                        self.$store.commit('SET_LARGE_FREESIZE', res.data.data.freeSize);
                        self.maxLargeAttachSize = self.largeFileSize(res.data.data.freeSize);
                    }
                })
            })(xmail.api, xmail.enums, xmail.pms);
            (function (api, enums, pms) {
                let pm = pms.LargeFile.getFileListParamBuilder();
                pm.currentPage = 1;
                pm.pageSize = 9999;
                api.LargeFile.getFileList(pm, function (res) {
                    const data = res.data;
                    if (data.code === 0) {
                        self.largeAttachData = data.data.mailAccountFilePage.records.filter(
                            item => item.expireDate - new Date() > 0
                        );
                    }
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        goSetFont() {
            this.timgSaveDraft();
            this.$router.push({name: 'generalSettings', params: {activeIndex: '5'}});
        },
        setSignCommand(command) {
            if(command === 'setSign') {
                this.timgSaveDraft();
                this.$router.push({name: 'signatureSetting', params: {activeIndex: '7'}});
            } else {
                this.getSignature(command);
            }
        },
        getSignature(command) {
            // console.log(this.persSignList);
            if (command === 'notUse') {
                this.signNotUse = true;
                this.signIdCurr = '';
                this.editorSign = '';
            } else {
                this.signNotUse = false;
                if (this.persSignList.length > 0) {
                    if (command === 'init') {
                        let defaultSign = this.persSignList.find(item => item.mailAccountDef === true);
                        if (!defaultSign) {
                            this.signNotUse = true;
                        } else {
                            this.editorSign = defaultSign.content;
                            this.signIdCurr = defaultSign.signId;
                        }
                    } else {
                        let currSign = this.persSignList.find(item => item.signId === command);
                        this.editorSign = currSign.content;
                        this.signIdCurr = command;
                    }
                }
            }

            setTimeout(() => {
                this.appendSignature(this, command);
            }, 500);

            if (command === 'init') {
                setTimeout(() => {
                    this.setWriteDataStore();
                }, 1000)
            }
        },
        setSenderCommand(command) {
            if (command === 'setSender') {
                this.timgSaveDraft();
                this.$router.push({name: 'generalSettings', params: {activeIndex: '5'}});
            } else {
                this.mailFrom = command;
            }
        },
        editLabel(labTxt, e) {
            //console.log(e)
            this.editingLabel = true;
            this.dblclickLabel = labTxt.org;
            this.currEditLabelVal = emailUtil.toEmailsLabel({name: labTxt.name, email: labTxt.org});
        },
        cancelSelectContact() {
            this.selectContactVisible = false;
        },
        /**
         * 添加收件人、抄送、密送
         * @param rcpts
         */
        addRcpts(rcpt, type) {
            let addr = {org: rcpt.email, name: rcpt.name}
            let info = this.getFormData(type);
            let existAddrs = info.label.map(item => {
                return item.org
            });
            if (existAddrs.includes(addr.org)) { //剔重
                return;
            }
            if (info.pos < 0 || info.pos >= info.label.length) {
                info.label.push(addr);
            } else {
                info.label.splice(info.pos, 0, addr);
                this.incInputPos(type, 1);
            }
            this.clearAutocomplete(type);
            this.focusInput(type);
        },

        /**
         * 移除指定收件人、抄送、密送
         * @param rcpts
         * @param index
         */
        removeRcpts(index, type) {
            switch (type) {
                case 'rec':
                    this.form.receiverLabel.splice(index, 1);
                    break;
                case  'cc':
                    this.form.ccLabel.splice(index, 1);
                    break;
                case 'bcc':
                    this.form.bccLabel.splice(index, 1);
                    break;
                default:
                    this.selectedRcpts.splice(index, 1);
            }
            this.incInputPos(type, 0);
            // this.selectedRcpts.splice(index, 1);
        },
        getOrgTrees(nodes) {
            this.orgTrees = nodes;
        },
        getPersTrees(nodes) {
            this.persTrees = nodes;
        },
        getMailContact(contactData) {
            // console.log(contactData)
            let tosArr = [];
            contactData.tos.forEach((item, index) => {
                tosArr.push(item.name + '<' + item.email + '>')
            })
            let ccsArr = [];
            contactData.ccs.forEach((item, index) => {
                ccsArr.push(item.name + '<' + item.email + '>')
            })
            let bccsArr = [];
            contactData.bccs.forEach((item, index) => {
                bccsArr.push(item.name + '<' + item.email + '>')
            })

            this.form.receiver = tosArr.map(v => v.replace(/[,;|]/g, '')).toString();
            this.form.receiverLabel = [];
            this.addresseeLabel('rec');

            this.form.cc = ccsArr.map(v => v.replace(/[,;|]/g, '')).toString();
            this.form.ccLabel = [];
            this.addresseeLabel('cc');

            this.form.bcc = bccsArr.map(v => v.replace(/[,;|]/g, '')).toString();
            this.form.bccLabel = [];
            this.addresseeLabel('bcc');

            this.showBccer = (bccsArr.length !== 0);
        },
        appendSignature(self, command) {
            let ed = tinymce.get('tinymceEditor');
            if (ed) {
                let signWrap = ed.getDoc().getElementById('personalSignatureWrap');
                if (signWrap) {
                    if(self.$route.params.type !== 'draft' && self.$route.params.type !== 'sent') {
                      signWrap.innerHTML = self.editorSign;
                    } else {
                      if(command !== 'init') {
                        signWrap.innerHTML = self.editorSign;
                      }
                    }
                }
                self.editorContent = ed.getContent();
            }
        },
        replyAddData(data, type) {
          // 在索引页签点击浏览器后退键回退到写信页签带出所选信件的发件人问题
          if (!this.$route.params.type) {
            return;
          }
          // 当前开启写信页签时（回复等）再在索引页选中其他信件点击回复转发时清除原地址栏
          this.form.receiver = '';
          this.form.receiverLabel = [];
          this.form.cc = '';
          this.form.ccLabel = [];
          this.form.bcc = '';
          this.form.bccLabel = [];

            if (type === 'write') {
                this.form.receiver = '';
                this.form.receiverLabel = [];
                // this.form.receiverErrorLabel = [];
                this.form.cc = '';
                this.form.ccLabel = [];
                // this.form.ccErrorLabel = [];
                this.form.bcc = '';
                this.form.bccLabel = [];
                // this.form.bccErrorLabel = [];
                this.form.subject = '';
                this.editorContent = `<div class="write-custom-wrap">${this.editorInitDom}</div><div id="personalSignatureWrap"></div>`;
                this.attachInfos = [];
                if (this.$route.params.addr) {
                    this.form.receiver = this.$route.params.addr;
                    this.addresseeLabel('rec');
                }
                if (this.$route.params.largeAttach) {
                    this.$route.params.largeAttach.forEach((item, index) => {
                        this.attachInfos.push({
                            id: 'listLargeAttach_' + index,
                            fileId: item.mailAccountFileId,
                            fileName: item.name,
                            size: item.size,
                            isLarge: true
                        });
                    })
                }
            } else {
                // console.log(data);
                let replyEditorInfo = `<div class="write-custom-wrap">${this.editorInitDom}</div><div id="personalSignatureWrap"></div>` +
                    '<div style="padding:5px;padding-left:0px;border-top:solid #999 1.0pt;font-family: arial; font-size:12px;margin-bottom:20px;">' +
                    '<p><strong>From:</strong>' + data.from + '</p>' +
                    '<p><strong>To:</strong>' + data.to.toString() + '</p>' +
                    '<p><strong>CC:</strong>' + data.cc.toString() + '</p>' +
                    '<p><strong>Sent:</strong>' + this.$moment(data.sendDate).format('YYYY-MM-DD HH:mm:ss') + '</p>' +
                    '<p><strong>Subject:</strong>' + data.subject + '</p></div>';

                this.attachInfos = [];

                if (type === 'forward') {
                    this.editorContent = replyEditorInfo + data.mailText;
                    this.form.subject = this.subjectFw + data.subject;
                    if (data.attachInfos.length !== 0) {
                        data.attachInfos.map(item => {
                            return {
                                fileId: item.fileId,
                                fileName: item.fileName,
                                size: item.size,
                                isLarge: false
                            }
                        });
                        this.attachInfos = data.attachInfos;
                    } else {
                        this.attachInfos = [];
                    }
                }
                if (type === 'forwardMultiple') {
                    this.form.subject = this.subjectFw + data.subject;
                    this.editorContent = `<div class="write-custom-wrap">${this.editorInitDom}</div><div id="personalSignatureWrap"></div>`;
                    let mails = this.$store.getters.checkedMails;
                    let mailIds = mails.map(item => {
                        return item.mailIndexId
                    });
                    let self = this;
                    (function (api, enums, pms) {
                        let pm = pms.MailFile.getForwardMailInfoParamBuilder();
                        pm.mailIndexIds = mailIds;
                        api.MailFile.getForwardMailInfo(pm, function (res) {
                            let forwardMailInfos = [];
                            if (res.data.data.forwardMailInfos.length !== 0) {
                                forwardMailInfos = res.data.data.forwardMailInfos.map(item => {
                                    return {
                                        fileId: item.fileId,
                                        fileName: item.fileName,
                                        size: item.fileSize,
                                        fileSize: item.fileSize,
                                        isLarge: false
                                    }
                                })
                            }
                            self.attachInfos = forwardMailInfos;
                            setTimeout(() => {
                                self.appendSignature(self);
                                self.setWriteDataStore();
                            }, 500);
                        })
                    })(xmail.api, xmail.enums, xmail.pms);
                }
                if (type === 'forwardTbSingle') {
                    // console.log(data);
                    this.form.subject = this.subjectFw + data.subject;
                    this.editorContent = `<div class="write-custom-wrap">${this.editorInitDom}</div><div id="personalSignatureWrap"></div>` + data.mailText;
                    if (data.attachInfos.length !== 0) {
                        data.attachInfos.map(item => {
                            return {
                                fileId: item.fileId,
                                fileName: item.fileName,
                                size: item.size,
                                isLarge: false
                            }
                        });
                        this.attachInfos = data.attachInfos;
                    } else {
                        this.attachInfos = [];
                    }
                    setTimeout(() => {
                        this.appendSignature(this);
                        this.setWriteDataStore();
                    }, 500);
                }
                if (type === 'reply') {
                    this.form.receiver = data.from.toString();
                    this.addresseeLabel('rec');
                    this.form.subject = this.subjectRe + data.subject;
                    // 回复时加入原信
                    if (this.replyWithContent) {
                        this.editorContent = replyEditorInfo + data.mailText;
                    }
                }
                if (type === 'replyAll') {
                  let pattern = this.localUserInfo.userEmail;
                  let filteredArray = _.filter(data.to, function(item) {
                    return !_.includes(item, pattern);
                  });
                  this.form.receiver = data.from.toString() + ',' + filteredArray.toString();
                    this.form.cc = data.cc.toString();
                    this.form.bcc = data.bcc.toString();
                    this.addresseeLabel('rec');
                    this.addresseeLabel('cc');
                    this.addresseeLabel('bcc');
                    this.form.subject = this.subjectRe + data.subject;
                    // 回复时加入原信
                    if (this.replyWithContent) {
                        this.editorContent = replyEditorInfo + data.mailText;
                    }
                }
                if (type === 'replyAllAttach') {
                    let pattern = this.localUserInfo.userEmail;
                    let filteredArray = _.filter(data.to, function(item) {
                      return !_.includes(item, pattern);
                    });
                    this.form.receiver = data.from.toString() + ',' + filteredArray.toString();
                    this.form.cc = data.cc.toString();
                    this.form.bcc = data.bcc.toString();
                    this.addresseeLabel('rec');
                    this.addresseeLabel('cc');
                    this.addresseeLabel('bcc');
                    this.form.subject = this.subjectRe + data.subject;
                    // 回复时加入原信
                    if (this.replyWithContent) {
                        this.editorContent = replyEditorInfo + data.mailText;
                    }
                    // this.attachInfos = data.attachInfos;
                    if (data.attachInfos.length !== 0) {
                        data.attachInfos.map(item => {
                            return {
                                fileId: item.fileId,
                                fileName: item.fileName,
                                size: item.size,
                                isLarge: false
                            }
                        })
                    }
                    // console.log(data.attachInfos)
                    this.attachInfos = data.attachInfos;
                }
            }
            //添加默认抄送密送
            if (this.localConfigSetting.deliverSetting.ccDef) {
                this.form.cc = this.form.cc + this.localConfigSetting.deliverSetting.ccDef;
                this.addresseeLabel('cc');
            }
            if (this.localConfigSetting.deliverSetting.bccDef) {
                this.showBccer = true;
                this.form.bcc = this.form.bcc + this.localConfigSetting.deliverSetting.bccDef;
                this.addresseeLabel('bcc');
            }
            this.setWriteDataStore();
        },
        editAgainData(data, type) {
            // console.log(type);
            // console.log(data);
            let self = this;
            //再次编辑时已开写信页签内容初始化
            self.form.receiver = '';
            self.form.receiverLabel = [];
            self.form.cc = '';
            self.form.ccLabel = [];
            self.form.bcc = '';
            self.form.bccLabel = [];
            self.form.subject = '';
            self.attachInfos = [];
            (function (api, enums, pms) {
                let mId = self.$route.params.mid;
                // let mId = this.mailId;
                // let fId = self.$store.state.folder.folderId;
                let fileId = self.$route.params.fileId;
                let mailRead = self.$route.params.read;
                let rpm = pms.MailFile.getMailInfoParamBuilder();
                rpm.mailIndexId = mId;
                rpm.fileId = fileId;
                // rpm.folderId = fId;
                rpm.mailStatus = enums.MailStatus.UNREAD
                if (mailRead === true) {
                    rpm.mailStatus = enums.MailStatus.READ
                }

                // 获取邮件
                api.MailFile.getMailInfo(rpm, function (res) {
                    // console.log(res.data);
                    if (res.data.code === 0) {
                        let mailAgainData = res.data.data.mailInfo;
                        let mailAgainMailIndex = res.data.data.mailIndex;
                        self.$store.commit('SET_MAIL_DATA', mailAgainData);
                        self.currentDraftMailIndexId = self.$store.getters.currWriteType === 'draft' ? self.$store.getters.mailData.mailIndexId : '';
                        self.form.subject = mailAgainData.subject;
                        self.form.receiver = mailAgainData.to.toString();
                        self.form.cc = mailAgainData.cc.toString();
                        self.form.bcc = mailAgainData.bcc.toString();
                        self.addresseeLabel('rec');
                        self.addresseeLabel('cc');
                        self.addresseeLabel('bcc');
                        self.showBccer = (mailAgainData.bcc.length !== 0);
                        // this.attachInfos = data.attachInfos;
                        if (mailAgainData.attachInfos.length !== 0) {
                            mailAgainData.attachInfos.map(item => {
                                return {
                                    fileId: item.fileId,
                                    fileName: item.fileName,
                                    size: item.size,
                                    isLarge: false
                                }
                            })
                        }
                        self.attachInfos = mailAgainData.attachInfos;
                        // self.editorContent = mailAgainData.mailText;
                        self.editorContent = `<div class="write-custom-wrap">${self.editorInitDom}</div>` + mailAgainData.mailText;
                        //定时发信回显
                        let isTimingMail = self.isTimingMail(mailAgainMailIndex.attrFlag);
                        if(isTimingMail) {
                          self.sendOtherOption.timing = true;
                          self.sendOtherOption.mtaTime = mailAgainData.sendDate ? mailAgainData.sendDate : '';
                          self.timingMailFlag = true;
                        } else {
                          self.sendOtherOption.timing = false;
                          self.sendOtherOption.mtaTime = '';
                          self.timingMailFlag = false;
                        }
                        //加密邮件回显
                        if(mailAgainData.encryptMail && mailAgainData.selfMailFlag) {
                            self.cancelPassword = true;
                            self.sendOtherOption.encryptMail = true;
                            self.againMailPw(mailAgainData.mailIndexId);
                        }
                        setTimeout(() => {
                            self.setWriteDataStore();
                        }, 500);
                    }
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        againMailPw(mid) {
          let self = this;
          (function (api, enums, pms) {
            let pm = pms.MailFile.getEncryptMailPasswdParamBuilder();
            pm.mailIndexId = mid;
            api.MailFile.getEncryptMailPasswd(pm, function (res) {
              if(res.data.code === 0) {
                self.mailPassword = res.data.data.mailPasswd;
                self.encryptForm.pw = res.data.data.mailPasswd;
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        },
        fileDragover(e) {
            this.dropUpload = true;
            e.preventDefault()
        },
        // ---- 添加附件 ----
        fileChange(file) {
            if (!file.size) return;
            this.fileList.push(file);
            this.dialogAttachVisible = false;
            // console.log(file);
            this.attachUploadingRecords.push(file.id);
        },
        uploadError(file) {
            this.attachUploadingRecords.splice(this.attachUploadingRecords.findIndex(item => item.id === file.id), 1);
        },
        openLargeAttach(fileList) {
            let self = this;
            console.log(fileList);
            // fileList.forEach(item => {})
            (function (api, enums, pms) {
                api.LargeFile.getSpaceInfo({}, function (res) {
                    // console.log(res.data.data)
                    if (res.data.code === 0) {
                        self.$store.commit('SET_LARGE_FREESIZE', res.data.data.freeSize);
                        self.maxLargeAttachSize = self.largeFileSize(res.data.data.freeSize);
                        fileList.forEach(item => {
                            self.$refs.uploaderLarge.uploaderLarge.addFiles(item);
                        });
                    }
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        onProgress(file, percent) {
            $(`.file-${file.id} .progress`).css('width', percent * 100 + '%');
            $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + '%');
            $(`.file-${file.id} .el-icon-loading`).hide();
            $(`.file-${file.id} .cancel-file-upload`).show();
        },
        onSuccess(file, response, opt) {
            // console.log('success');
            this.dropUpload = false;
            if (!this.form.subject) {
                this.form.subject = file.name.substring(0, file.name.lastIndexOf("."));
            }
            let self = this;
            let lastModifiedDate = this.$moment(new Date(file.lastModifiedDate)).format('YYYY-MM-DD HH:mm:ss')
            let _key = '' + this.$store.getters.user + file.name + lastModifiedDate + file.size;
            let uniqueFileName = opt.md5;
            let realFileName = file.name;
            let fileExt = file.ext;
            // this.attachInfos.push({id: file.id, fileId: response.data.fid, fileName: response.data.fileName});//id用于附件删除（后端接口不需要）
            let chunksTotal = 0;
            if ((chunksTotal = Math.ceil(file.size / this.chunkSize)) > 1) {
                (function (api, enums, pms) {
                    let fpm = pms.File.chunksMergeParamBuilder();
                    fpm.fileName = uniqueFileName;
                    fpm.realFileName = realFileName;
                    fpm.chunksTotal = chunksTotal;
                    fpm.fileExt = fileExt;
                    // fpm.md5 = '';
                    api.File.chunksMerge(fpm, function (res) {
                        // console.log(res);
                        // file.path = res.path;
                        let $fileStatus = $(`.file-${file.id} .file-status`);
                        if (res.data.code === 0) {
                            // $fileStatus.html(this.$i18n.t('wm_lang_a7699b'));
                            let index = self.fileList.findIndex(ele => ele.id === file.id);
                            self.fileList.splice(index, 1);
                            self.attachInfos.push({
                                id: file.id,
                                fileId: res.data.data.fid,
                                fileName: res.data.data.fileName,
                                size: res.data.data.fileSizeBytes,
                                isLarge: false
                            });
                        } else {
                            $fileStatus.html(this.$i18n.t('wm_lang_54e5de'));
                        }
                        $(`.file-${file.id} .cancel-file-upload`).hide();
                        $(`.file-${file.id} .remove-file-upload`).show();
                        // self.attachInfos.push({id: file.id, fileId: res.data.data.fid, fileName: res.data.data.fileName});
                        //移除上传完成的附件ID
                        // console.log(file);
                        self.attachUploadingRecords.splice(self.attachUploadingRecords.findIndex(item => item.id === file.id), 1);
                    })
                })(xmail.api, xmail.enums, xmail.pms);
            } else {
                // console.log(response);
                let index = self.fileList.findIndex(ele => ele.id === file.id);
                self.fileList.splice(index, 1);
                self.attachInfos.push({
                    id: file.id,
                    fileId: response.data.fid,
                    fileName: response.data.fileName,
                    size: response.data.fileSizeBytes,
                    isLarge: false
                });//id用于附件删除（后端接口不需要）
                //移除上传完成的附件ID
                // console.log(file);
                // console.log(self.attachUploadingRecords);
                self.attachUploadingRecords.splice(self.attachUploadingRecords.findIndex(item => item.id === file.id), 1);
            }
        },
        onSuccessLarge(file, response, opt) {
            // console.log(this.$i18n.t('wm_lang_dac715'), response);
            // console.log(file);
            // console.log(opt);
            this.dialogAttachVisible = false;
            if (!this.form.subject) {
                this.form.subject = file ? file.name.substring(0, file.name.lastIndexOf(".")) : '';
            }
            if (opt.listAdd) {
                opt.largeAttachs.forEach((item, index) => {
                    this.attachInfos.push({
                        id: 'listLargeAttach_' + index,
                        fileId: item.mailAccountFileId,
                        fileName: item.name,
                        size: item.size,
                        isLarge: true
                    });
                });
                this.selectedLargeAttach = [];
                return;
            }
            if (opt.existed) { //秒传
                this.attachInfos.push({id: file.id, fileId: opt.fileId, fileName: file.name, size: file.size, isLarge: true});
                let index = this.fileList.findIndex(ele => ele.id === file.id);
                this.fileList.splice(index, 1);
                this.attachUploadingRecords.splice(this.attachUploadingRecords.findIndex(item => item.id === file.id), 1);
                // console.log(this.attachUploadingRecords);
                return;
            }
            let self = this;
            (function (api, enums, pms) {
                let pm = pms.FileTransfer.completedFileChunkUploadParamBuilder();
                pm.md5 = opt.md5;
                pm.size = file.size;
                pm.token = opt.token;
                api.FileTransfer.completedFileChunkUpload(pm, function (res) {
                    let $fileStatus = $(`.file-${file.id} .file-status`);
                    if (res.data.code === 0) {
                        // console.log(file);
                        // $fileStatus.html(this.$i18n.t('wm_lang_a7699b'));
                        let index = self.fileList.findIndex(ele => ele.id === file.id);
                        self.fileList.splice(index, 1);
                        self.attachInfos.push({
                            id: file.id,
                            fileId: res.data.data.mailAccountFileId,
                            fileName: file.name,
                            size: file.size,
                            isLarge: true
                        });
                    } else {
                        $fileStatus.html(this.$i18n.t('wm_lang_54e5de'));
                    }
                    $(`.file-${file.id} .cancel-file-upload`).hide();
                    $(`.file-${file.id} .remove-file-upload`).show();
                    //移除上传完成的附件ID
                    // console.log(file);
                    // console.log(self.attachUploadingRecords);
                    self.attachUploadingRecords.splice(self.attachUploadingRecords.findIndex(item => item.id === file.id), 1);
                })
            })(xmail.api, xmail.enums, xmail.pms);
            // let chunksTotal = 0;
            // if ((chunksTotal = Math.ceil(file.size/this.chunkSize)) > 1) {
            //   (function (api, enums, pms) {
            //     let pm = pms.FileTransfer.completedFileChunkUploadParamBuilder();
            //     pm.md5 = opt.md5;
            //     pm.size = file.size ;
            //     pm.token = opt.token;
            //     api.FileTransfer.completedFileChunkUpload(pm, function (res) {
            //       let $fileStatus = $(`.file-${file.id} .file-status`);
            //       if (res.data.code === 0) {
            //         console.log(file);
            //         $fileStatus.html(this.$i18n.t('wm_lang_a7699b'));
            //         let index = self.fileList.findIndex(ele => ele.id === file.id);
            //         self.fileList.splice(index, 1);
            //         self.attachInfos.push({id: file.id, fileId: res.data.data.mailAccountFileId, fileName: file.name, size: file.size, isLarge: true});
            //       } else {
            //         $fileStatus.html(this.$i18n.t('wm_lang_54e5de'));
            //       }
            //       $(`.file-${file.id} .cancel-file-upload`).hide();
            //       $(`.file-${file.id} .remove-file-upload`).show();
            //       // self.attachInfos.push({id: file.id, fileId: res.data.data.fid, fileName: res.data.data.fileName});
            //     })
            //   })(xmail.api, xmail.enums, xmail.pms);
            // } else {
            //   console.log(response);
            //   let index = self.fileList.findIndex(ele => ele.id === file.id);
            //   self.fileList.splice(index, 1);
            //   self.attachInfos.push({id: file.id, fileId: '', fileName: file.name, size: file.size, isLarge: true});//id用于附件删除（后端接口不需要）
            // }
        },
        // resume(file) {
        //   this.uploader.upload(file);
        // },
        // stop(file) {
        //   this.uploader.stop(file);
        // },
        removeAttach(idx) {
            // console.log(idx)
            // 取消并中断文件上传
            // this.uploader.cancelFile(file);
            // 在队列中移除文件
            // this.uploader.removeFile(file, true);
            // 在ui上移除
            // let index = this.fileList.findIndex(ele => ele.id === file.id);
            // this.fileList.splice(index, 1);
            // let attIndex = this.attachInfos.findIndex(ele => ele.id === file.id);
            let attIndex = idx;
            this.attachInfos.splice(attIndex, 1);
        },
        cancelFile(file) {
            // console.log(this.uploader)
            // console.log(this.uploaderLarge);
            // 取消并中断文件上传
            this.uploader.cancelFile(file);
            this.uploaderLarge.cancelFile(file);
            // 在队列中移除文件
            this.uploader.removeFile(file, true);
            this.uploaderLarge.removeFile(file, true);
            // 在ui上移除
            let index = this.fileList.findIndex(ele => ele.id === file.id);
            this.fileList.splice(index, 1);
            // 上传队列移除
            this.attachUploadingRecords.splice(this.attachUploadingRecords.findIndex(item => item.id === file.id), 1);
        },
        removeFile(file) {
            // 取消并中断文件上传
            // console.log(this.uploader);
            // console.log(this.uploaderLarge);
            this.uploader.cancelFile(file);
            this.uploaderLarge.cancelFile(file);
            // 在队列中移除文件
            this.uploader.removeFile(file, true);
            this.uploaderLarge.removeFile(file, true);
            // 在ui上移除
            let index = this.fileList.findIndex(ele => ele.id === file.id);
            this.fileList.splice(index, 1);
            let attIndex = this.attachInfos.findIndex(ele => ele.id === file.id);
            this.attachInfos.splice(attIndex, 1);
        },
        fileSize(size) {
            return WebUploader.Base.formatSize(size);
        },
        // ---- 添加附件End ----
        // 鼠标单击的事件
        onClick(e, editor) {
            console.log('Element clicked')
            console.log(e)
            console.log(editor)
        },
        // 清空内容
        clear() {
            this.$refs.editor.clear()
        },
        getAddressees(type) {
            let res = this.getFormData(type);
            return res.label.map(item => {
                return emailUtil.toEmailsLabel({name: item.name, email: item.org});
            });
        },
        addrKeydown(e, type) {
            //console.log(e)
            //console.log(e.keyCode);
            //退格键
            if (e.keyCode === 8 && !e.target.value) {
                let info = this.getFormData(type);
                if (info.pos > 0 && info.pos < info.label.length) {
                    info.label.splice(info.pos - 1, 1);
                    this.incInputPos(type, -1);
                } else if (info.pos !== 0) {
                    info.label.pop();
                    this.incInputPos(type, 0);
                }
                this.focusInput(type);
            }
            //地址栏联想列表上下键
            else if (e.keyCode === 38) {
                if (this.autocompleteItemsIndex >= 1) {
                    this.autocompleteItemsIndex--;
                } else {
                    this.autocompleteItemsIndex = this.autocompleteItems.length - 1;
                }
            } else if (e.keyCode === 40) {
                if (this.autocompleteItemsIndex < this.autocompleteItems.length - 1) {
                    this.autocompleteItemsIndex++;
                } else {
                    this.autocompleteItemsIndex = 0;
                }
                // console.log(this.autocompleteItemsIndex)
            }
            // 联想出的列表项选中回车
            else if (e.keyCode === 13 || e.key === ',' || e.key === ';' || e.key === ' ' || e.key === '|') {
                if (this.autocompleteItems.length > 0) {
                    this.addRcpts(this.autocompleteItems[this.autocompleteItemsIndex], type);
                    this.autocompleteItemsIndex = 0;
                }
            }
            //Del
            else if (46 === e.keyCode && !e.target.value) {
                let info = this.getFormData(type);
                if (info.pos >= 0 && info.pos < info.label.length) {
                    this.removeRcpts(info.pos, type);
                }
                this.focusInput(type);
            }
        },
        focusInput(type) {
            let slef = this;
            _.throttle(function (event) {
                let refInput;
                switch (type) {
                    case 'rec':
                        slef.form.receiver = '';
                        refInput = slef.form.recInputPos >= 0 ? 'recInput' + slef.form.recInputPos : 'recInput';
                        break;
                    case 'cc':
                        slef.form.cc = '';
                        refInput = slef.form.ccInputPos >= 0 ? 'ccInput' + slef.form.ccInputPos : 'ccInput';
                        break;
                    case 'bcc':
                        slef.form.bcc = '';
                        refInput = slef.form.bccInputPos >= 0 ? 'bccInput' + slef.form.bccInputPos : 'bccInput';
                        break;
                }
                console.log(refInput);
                console.log(slef.$refs[refInput]);
                try {
                    slef.$refs[refInput].focus();
                } catch (e) {
                }
                try {
                    slef.$refs[refInput][0].focus();
                } catch (e) {
                }
            }, 160, {'leading': false})();
        },
        focusInputPos(type, num) {
            this.setInputPos(type, num);
            this.focusInput(type);
        },
        addrKeyup(e, type) {
            //console.log(e.keyCode);
            this.addrEditKeyup(e, type);

            //左键
            if (37 === e.keyCode && !e.target.value) {
                this.incInputPos(type, -1);
                this.focusInput(type);
            }
            //右键
            else if (39 === e.keyCode && !e.target.value) {
                this.incInputPos(type, 1);
                this.focusInput(type);
            }
            //Home
            else if (36 === e.keyCode && !e.target.value) {
                this.incInputPos(type, -10000);
                this.focusInput(type);
            }
            //End
            else if (35 === e.keyCode && !e.target.value) {
                this.setInputPos(type, -1);
                this.focusInput(type);
            }
        },
        selectLabel(label) {
            this.selectedLabel = label
        },
        addrEditKeyup(e, type) {
            if (e.keyCode === 13 || e.keyCode === 186 || e.keyCode === 188
                || ((e.key === ',' || e.key === ';' || e.key === ' ' || e.key === '|')
                    && e.target.value && e.target.value.endsWith(e.key))) {
                e.target.blur();
                this.focusInput(type);
            }
        },
        labelEdit(addressee, addresseeLabel, labelIndex) {
            if (labelIndex >= 0 && labelIndex < addresseeLabel.length) {
                addresseeLabel.splice(labelIndex, 1);
            }
            this.labelCreate(addressee, addresseeLabel, labelIndex);
        },
        editLabelFocus() {
            this.editingLabel = true;
        },
        addresseeLabelEdit(type, index) { //修改发信联系人标签
            this.editingLabel = false;
            //console.log(index)
            //console.log(this.currEditLabelVal)
            // console.log(this.form.receiverLabel)
            switch (type) {
                case 'rec':
                    this.labelEdit(this.currEditLabelVal, this.form.receiverLabel, index);
                    break;
                case 'cc':
                    this.labelEdit(this.currEditLabelVal, this.form.ccLabel, index);
                    break;
                case 'bcc':
                    this.labelEdit(this.currEditLabelVal, this.form.bccLabel, index);
                    break;
            }
            if (!this.currEditLabelVal) {
                this.removeRcpts(index, type);
            }
        },
        addresseeLabel(type) { //添加发信联系人标签
            let slef = this;
            _.throttle(function (event) {
                // let addrs = [];
                // console.log(this.form.receiver)
                // console.log(this.form.receiverLabel)
                let count = 0;
                switch (type) {
                    case 'rec':
                        count = slef.labelCreate(slef.form.receiver, slef.form.receiverLabel, slef.form.recInputPos);
                        slef.form.receiver = '';
                        break;
                    case 'cc':
                        count = slef.labelCreate(slef.form.cc, slef.form.ccLabel, slef.form.ccInputPos);
                        slef.form.cc = '';
                        break;
                    case 'bcc':
                        count = slef.labelCreate(slef.form.bcc, slef.form.bccLabel, slef.form.bccInputPos);
                        slef.form.bcc = '';
                        break;
                }
                slef.incInputPos(type, count);
            }, 160, {'leading': false})();
        },
        labelCreate(addressee, addresseeLabel, labelIndex) {
            let addrs = emailUtil.parseEmailsLabel(addressee);
            if (addrs.length <= 0) {
                return 0;
            }
            let existAddrs = addresseeLabel.map(item => {
                return item.org
            });
            let count = 0;
            const insert = labelIndex >= 0 && labelIndex < addresseeLabel.length;
            addrs.forEach((item, index) => {
                if (!item.email || existAddrs.includes(item.email)) { //剔重
                    return;
                }
                existAddrs.push(item.email);
                let info = {org: item.email, name: item.name};

                if (isEmail(item.email)) {
                    if (!info.name.trim()) {
                        info.name = item.email.split('@')[0];
                    }
                } else {
                    info.name = item.email;
                    info.errorAddress = true;
                }

                if (insert) {
                    addresseeLabel.splice(labelIndex + count, 0, info);
                } else {
                    addresseeLabel.push(info);
                }
                count++;
            });

            return count;
        },
        // closeLabel(addr,right,type) {
        //   switch (type) {
        //     case 'rec':
        //       if(right){
        //         this.form.receiverLabel.splice(this.form.receiverLabel.findIndex(item => item === addr), 1);
        //       } else {
        //         this.form.receiverErrorLabel.splice(this.form.receiverErrorLabel.findIndex(item => item === addr), 1);
        //       }
        //       break;
        //     case 'cc':
        //       if(right){
        //         this.form.ccLabel.splice(this.form.ccLabel.findIndex(item => item === addr), 1);
        //       } else {
        //         this.form.ccErrorLabel.splice(this.form.ccErrorLabel.findIndex(item => item === addr), 1);
        //       }
        //       break;
        //     case 'bcc':
        //       if(right){
        //         this.form.bccLabel.splice(this.form.bccLabel.findIndex(item => item === addr), 1);
        //       } else {
        //         this.form.bccErrorLabel.splice(this.form.bccErrorLabel.findIndex(item => item === addr), 1);
        //       }
        //       break;
        //   }
        // },
        cancelSend() {
            this.$EventBus.$emit("closeWritePage", {type: 'common'});
        },
        draftMail() {
            // console.log(this.form)
            // console.log(this.editorContent)
            // console.log(this.$route.params);
            //------保存草稿--------
            let self = this;
            (function (api, enums, pms) {
                let receiverArr = self.getAddressees('rec');
                let ccArr = self.getAddressees('cc');
                let bccArr = self.getAddressees('bcc');
                let spm = pms.MailFile.saveDraftMailParamBuilder();
                let userInfo = storeLocal.get('Pwm-userInfo');
                // let spmMailIndexId = '';
                spm.from = self.mailFrom ? self.mailFrom : userInfo.userEmail;
                spm.to = receiverArr;
                spm.cc = ccArr;
                spm.bcc = bccArr;
                spm.subject = self.form.subject;
                spm.text = self.editorContent;
                spm.contentType = "";
                spm.sendMailType = enums.SendMailType.DRAFT;
                spm.mailIndexId = self.currentDraftMailIndexId;
                // spm.replyPreviousMailIndexId = spmMailIndexId;
                spm.mailOperatorType = enums.MailOperatorType.SEND;
                // spm.innerFileInfos = self.innerFileInfos;
                spm.attachInfos = self.attachInfos;
                // spm.saveSend = self.sendOtherOption.saveToSent ? enums.BooleanType.YES : enums.BooleanType.NO;
                // spm.needReceipt = self.sendOtherOption.receipt ? enums.BooleanType.YES : enums.BooleanType.NO;
                spm.saveSend = !!self.sendOtherOption.saveToSent;
                spm.needReceipt = !!self.sendOtherOption.receipt;
                spm.priority = self.sendOtherOption.urgent ? enums.MailPriority.URGENCY : enums.MailPriority.NORMAL;
                spm.sendAlone = !!self.sendOtherOption.sendAlone;
                spm.mtaTime = !!self.sendOtherOption.timing ? self.sendOtherOption.mtaTime : '';
                spm.encryptMail = !!self.sendOtherOption.encryptMail;
                spm.mtaFlag = self.timingMailFlag;
                if(spm.encryptMail) {
                    spm.mailPasswd = self.encryptForm.pw;
                }

                // console.log(spm)
                // return;

                //保存草稿数据集
                // let dataSet = self.writeDataSet();
                // self.$store.commit('SET_WRITEDATA_MD5',md5(JSON.stringify(dataSet)));
                self.setWriteDataStore();

                api.MailFile.saveDraftMail(spm, function (res) {
                    // console.log(res)
                    if (res.data.code === 0) {
                        if(res.data.data.mailIndexId) {
                            self.$message({
                              type: 'success',
                              message: self.$i18n.t('wm_lang_2f234b')
                            });
                            self.currentDraftMailIndexId = res.data.data.mailIndexId;
                            let storeRootFolderId = belongRootFolderId(self.$store.getters.folderId, self.$store.getters.folders);
                            if (storeRootFolderId === enums.FolderType.DRAFT_BOX_FOLDER_ID || storeRootFolderId === enums.FolderType.SEND_BOX_FOLDER_ID) {
                              //当前文件夹为草稿箱时，修改草稿fileId会改变，导致切换至索引时默认选中的当前编辑的草稿会报错
                              self.$store.commit('SET_CHECKED_MAILS', []);
                              self.$EventBus.$emit("getCurrFid", {folderId: self.$store.getters.folderId});
                            }
                        } else {
                          self.$message({
                            type: 'warning',
                            message: self.$i18n.t('wm_lang_19a1ee')
                          });
                        }
                    }
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        sendMail(val) {
            // console.log(this.form)
            // console.log(this.editorContent)
            //------非法地址提示--------
            setTimeout(() => {
                let allAddrs = [...this.form.receiverLabel, ...this.form.ccLabel, ...this.form.bccLabel];
                if (allAddrs.length === 0) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_10a48a')
                    });
                    return;
                }
                let errorAddrs = allAddrs.filter(item => this.isErrorAddress(item));
                let errorAddrsName = errorAddrs.map(item => item.name).join();
                if (errorAddrsName) {
                    this.$alert(`${this.$i18n.t('custom_lang_0005')}<br/>${errorAddrsName}`, this.$i18n.t('wm_lang_c45357'), {
                        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
                        dangerouslyUseHTMLString: true,
                        callback: action => {
                        }
                    });
                    return;
                }
                //单封邮件总大小限制校验
                // console.log(this.attachInfos);
                let totalAttachSize = 0;
                this.attachInfos.forEach(item => {
                    if (!item.isLarge) {
                        totalAttachSize += item.size
                    }
                });
                if (totalAttachSize > this.maxAttachSizeSingle * 1024 * 1024) {
                    this.$message({
                        type: 'warning',
                        message: `${this.$i18n.t('custom_lang_0043')}${this.maxAttachSizeSingle}M`
                    });
                    return;
                }
                if (this.attachUploadingRecords.length > 0) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('wm_lang_66f0da')+'...'
                    });
                    return;
                }
                let totalContactsCount = this.form.receiverLabel.length + this.form.ccLabel.length + this.form.bccLabel.length;
                if (totalContactsCount > this.maxToNumSingle) {
                    this.$message({
                        type: 'warning',
                        message: `${this.$i18n.t('custom_lang_0044')}${this.maxToNumSingle}${this.$i18n.t('wm_lang_465afe')}`
                    });
                    return;
                }
                if (this.sendOtherOption.timing && this.sendOtherOption.mtaTime === '') {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('custom_lang_0036')
                    });
                    return;
                }
                if (this.sendOtherOption.timing && this.sendOtherOption.mtaTime < new Date().getTime()) {
                    this.$message({
                        type: 'warning',
                        message: this.$i18n.t('custom_lang_0037')
                    });
                    return;
                }
                if (this.sendOtherOption.sendAlone) {
                    this.$confirm(this.$i18n.t('wm_lang_511fd1'), this.$i18n.t('wm_lang_c45357'), {
                        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
                        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
                        type: 'warning'
                    }).then(() => {
                        this.sendHandle();
                    }).catch(() => {
                        //
                    });
                    return;
                }
                if (!this.form.subject) {
                    this.$confirm(this.$i18n.t('wm_lang_9c49ab')+'?', this.$i18n.t('wm_lang_c45357'), {
                        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
                        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
                        closeOnClickModal: false,
                        type: 'warning'
                    }).then(() => {
                        this.sendHandle();
                    }).catch(() => {
                        //
                    });
                } else {
                    this.sendHandle();
                }
            }, 100)
        },
        sendHandle() {
            //------邮件发送--------
            this.$message({
                type: 'info',
                message: this.$i18n.t('wm_lang_237651')+'...',
                duration: 500
            });
            let self = this;
            let loading = this.$loading({text: this.$i18n.t('wm_lang_702513'), target: document.querySelector('.wmCloudsBox')});
            (function (api, enums, pms) {
                let receiverArr = self.getAddressees('rec');
                let ccArr = self.getAddressees('cc');
                let bccArr = self.getAddressees('bcc');
                let spm = pms.MailFile.sendMailParamBuilder();
                let userInfo = storeLocal.get('Pwm-userInfo');
                let mailData = self.$store.getters.mailData;
                let mailIndex = self.$store.getters.mailIndex;
                let currWriteType = self.$store.getters.currWriteType;
                let spmSendType = '';
                let spmOperType = '';
                let spmMailIndexId = '';
                let spmReplyMailIndexId = '';
                let spmForwardMailStatus = '';
                let spmReplyMailStatus = '';
                let forwardMultipleFlag = false;
                switch (currWriteType) {
                    case 'write':
                    case 'sent':
                        spmSendType = enums.SendMailType.NORMAL;
                        spmOperType = enums.MailOperatorType.SEND;
                        spmMailIndexId = '';
                        spmReplyMailIndexId = '';
                        break;
                    case 'reply':
                        spmSendType = enums.SendMailType.NORMAL;
                        spmOperType = enums.MailOperatorType.REPLY
                        spmMailIndexId = '';
                        spmReplyMailIndexId = mailData.mailIndexId;
                        spmReplyMailStatus = {answered: mailIndex.answered, forwarded: mailIndex.forwarded, seen: mailIndex.seen};
                        break;
                    case 'replyAll':
                        spmSendType = enums.SendMailType.NORMAL;
                        spmOperType = enums.MailOperatorType.REPLY_ALL
                        spmMailIndexId = '';
                        spmReplyMailIndexId = mailData.mailIndexId;
                        spmReplyMailStatus = {answered: mailIndex.answered, forwarded: mailIndex.forwarded, seen: mailIndex.seen};
                        break;
                    case 'replyAllAttach':
                        spmSendType = enums.SendMailType.NORMAL;
                        spmOperType = enums.MailOperatorType.REPLY_ALL_ATTACH;
                        spmMailIndexId = '';
                        spmReplyMailIndexId = mailData.mailIndexId;
                        spmReplyMailStatus = {answered: mailIndex.answered, forwarded: mailIndex.forwarded, seen: mailIndex.seen};
                        break;
                    case 'forward':
                    case 'forwardTbSingle':
                        spmSendType = enums.SendMailType.NORMAL;
                        spmOperType = enums.MailOperatorType.FORWARD;
                        spmMailIndexId = '';
                        spmReplyMailIndexId = mailData.mailIndexId;
                        spmForwardMailStatus = {answered: mailIndex.answered, forwarded: mailIndex.forwarded, seen: mailIndex.seen};
                        break;
                    case 'forwardMultiple':
                        spmSendType = enums.SendMailType.NORMAL;
                        spmOperType = enums.MailOperatorType.FORWARD;
                        spmMailIndexId = '';
                        spmReplyMailIndexId = '';
                        forwardMultipleFlag = true;
                        break;
                    case 'draft':
                        spmSendType = enums.SendMailType.DRAFT;
                        spmOperType = enums.MailOperatorType.SEND;
                        //列表布局不读信
                        spmMailIndexId = mailData !== null ? mailData.mailIndexId : self.$route.params.mid;
                        spmReplyMailIndexId = '';
                        break;
                    default:
                        spmSendType = enums.SendMailType.NORMAL;
                        spmOperType = enums.MailOperatorType.SEND;
                        spmMailIndexId = '';
                        spmReplyMailIndexId = '';
                }
                spm.from = self.mailFrom ? self.mailFrom : userInfo.userEmail;
                spm.to = receiverArr;
                spm.cc = ccArr;
                spm.bcc = bccArr;
                spm.subject = self.form.subject;
                spm.text = self.editorContent;
                spm.contentType = "";
                spm.sendMailType = spmSendType;
                // spm.mailIndexId = spmMailIndexId;
                //保存过草稿的信需要传保存草稿接口返回的mailIndexId
                if (currWriteType === 'draft') {
                    spm.mailIndexId = self.currentDraftMailIndexId ? self.currentDraftMailIndexId : spmMailIndexId;
                } else {
                    spm.mailIndexId = spmMailIndexId ? spmMailIndexId : self.currentDraftMailIndexId;
                }
                // spm.replyPreviousMailIndexId = spmReplyMailIndexId;
                if (spmOperType === enums.MailOperatorType.FORWARD) {
                    // spm.forwardPreviousMailStatus = [{mailIndexId: spmReplyMailIndexId, mailStatus: spmForwardMailStatus}];
                    if (forwardMultipleFlag) {
                        let mails = self.$store.getters.checkedMails;
                        // let mailIds = mails.map(item =>{return item.mailIndexId});
                        let forwardEmlStatus = [];
                        mails.forEach(item => {
                            forwardEmlStatus.push({
                                mailIndexId: item.mailIndexId,
                                mailStatus: {forwarded: item.forwarded, answered: item.answered, seen: item.seen}
                            })
                        });
                        spm.forwardPreviousMailStatus = forwardEmlStatus;
                    } else {
                        spm.forwardPreviousMailStatus = [{mailIndexId: spmReplyMailIndexId, mailStatus: spmForwardMailStatus}];
                    }
                }
                if (spmOperType === enums.MailOperatorType.REPLY || spmOperType === enums.MailOperatorType.REPLY_ALL || spmOperType === enums.MailOperatorType.REPLY_ALL_ATTACH) {
                    // console.log(mailData)
                    spm.replyPreviousMailStatus = {mailIndexId: spmReplyMailIndexId, mailStatus: spmReplyMailStatus};
                }
                spm.mailOperatorType = spmOperType;
                // spm.innerFileInfos = self.innerFileInfos;
                spm.attachInfos = self.attachInfos;
                // spm.saveSend = self.sendOtherOption.saveToSent ? enums.BooleanType.YES : enums.BooleanType.NO;
                // spm.needReceipt = self.sendOtherOption.receipt ? enums.BooleanType.YES : enums.BooleanType.NO;
                spm.saveSend = !!self.sendOtherOption.saveToSent;
                spm.needReceipt = !!self.sendOtherOption.receipt;
                spm.priority = self.sendOtherOption.urgent ? enums.MailPriority.URGENCY : enums.MailPriority.NORMAL;
                spm.sendAlone = !!self.sendOtherOption.sendAlone;
                spm.mtaTime = !!self.sendOtherOption.timing ? self.sendOtherOption.mtaTime : '';
                spm.encryptMail = !!self.sendOtherOption.encryptMail;
                spm.mtaFlag = self.timingMailFlag;
                if(spm.encryptMail) {
                    spm.mailPasswd = self.encryptForm.pw
                }

                // console.log(spm)
                // return;

                api.MailFile.sendMail(spm, function (res) {
                    // console.log(res)
                    loading.close();
                    if (res.data.code === 0) {
                        self.$message({
                            self: 'success',
                            message: self.$i18n.t('wm_lang_ff29b9')
                        });
                        self.$EventBus.$emit("closeWritePage", {type: 'sent'});
                        let storeRootFolderId = belongRootFolderId(self.$store.getters.folderId, self.$store.getters.folders);
                        if (storeRootFolderId === enums.FolderType.DRAFT_BOX_FOLDER_ID) {
                            self.$EventBus.$emit("getCurrFid", {folderId: self.$store.getters.folderId});
                        }
                        self.$router.push({path: '/home/sent'});
                        //开启了自动加入通信，发信后更新个人通讯录刷新标识
                        if(self.localConfigSetting.deliverSetting.orgVisible) {
                            self.$store.commit('SET_PERS_FRESH', true);
                        }
                    } else {
                        if (res.data.data && res.data.data.invalidAddress) {
                            self.invalidAddresses.push(...res.data.data.invalidAddress);
                        }
                        // WM -> SMTP{{$t("wm_lang_html_ec0bce")}}(2851~2900)
                        if ((res.data.code >= 2051 && res.data.code <= 2060) || (res.data.code >= 2851 && res.data.code <= 2900)) {
                            sendMailErrorAlert(res);
                        }
                    }
                })
            })(xmail.api, xmail.enums, xmail.pms);
        },
        getCreateDate(date) {
            if (date) {
                let timer = date - new Date().valueOf();
                if (timer && timer > 0) {
                    let days = timer / 1000 / 3600 / 24;
                    let day = Math.floor(days);
                    let hours = (days - day) * 24;
                    let hour = Math.floor(hours);
                    return `（${this.$i18n.t('wm_lang_43b510')}${day}${this.$i18n.t('wm_lang_249aba')}${hour}${this.$i18n.t('wm_lang_87ba17')}）`;
                }
            }
            return '';
        },
        isErrorAddress(item) {
            return item.errorAddress || this.invalidAddresses.includes(item.org);
        },
        incInputPos(type, num) {
            //console.log(type, num);
            let info = this.getFormData(type);
            if (info.label.length <= 0) {
                this.setInputPos(type, -1);
            } else {
                if (-1 === info.pos) {
                    info.pos = info.label.length;
                }
                info.pos += num;
                if (info.pos >= 0 && info.pos < info.label.length) {
                    this.setInputPos(type, info.pos);
                } else {
                    this.setInputPos(type, num < 0 ? 0 : -1);
                }
            }
        },
        setInputPos(type, num) {
            switch (type) {
                case 'rec':
                    this.form.recInputPos = num;
                    break;
                case  'cc':
                    this.form.ccInputPos = num;
                    break;
                case 'bcc':
                    this.form.bccInputPos = num;
                    break;
            }
        },
        getFormData(type) {
            let res = {};
            switch (type) {
                case 'rec':
                    res.pos = this.form.recInputPos;
                    res.label = this.form.receiverLabel;
                    break;
                case 'cc':
                    res.pos = this.form.ccInputPos;
                    res.label = this.form.ccLabel;
                    break;
                case 'bcc':
                    res.pos = this.form.bccInputPos;
                    res.label = this.form.bccLabel;
                    break;
            }
            return res;
        }
    }
}
</script>

<style lang="scss" scoped>
.wmCloudsWrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

$h-row: 28px;
.file-panel {
  // width: 840px;
  max-height: 200px;
  overflow-y: auto;

  .file-list {
    position: relative;
    height: auto;
  }

  .file-item {
    position: relative;
    // height: $h-row;
    // line-height: $h-row;
    line-height: normal;
    background-color: #fff;
    z-index: 1;

    > li {
      display: inline-block;
      padding: 4px 0;
    }

    > li:hover {
      background: #fafafb;
    }
  }

  /*.file-name {*/
  /*!*width: 100%;*!*/
  /*margin-left: 10px;*/
  /*}*/
  .file-status {
    width: 20%;
  }

  .progress {
    position: absolute;
    top: 0;
    left: 0;
    height: $h-row - 1;
    width: 0;
    background-color: #E2EDFE;
    z-index: -1;
  }
}

/deep/ .el-checkbox {
  margin-right: 0;
  margin-left: 5px
}

/*.tox-tinymce{height: calc(100vh - 336px)}*/
.writemailcontent {
  position: relative
}

.dropUploadMask {
  position: absolute;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(185, 185, 185, .75);
}

.dropUploadMask p {
  margin: 100px auto 0;
  color: #666;
  font: 16px/32px 'Microsoft YaHei';
  text-align: center
}

/deep/ #largeFilePicker {
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  outline: 0;
  color: #FFF;
  line-height: 40px;
  white-space: nowrap;
  cursor: pointer;
  margin: 0 0 0 10px;
  text-align: center;
  background-color: #3986ee !important;
  border-color: #3986ee !important;
  border-radius: 4px;
}

.largeAttach-list {
  width: 100%;
  max-height: 200px;
  display: inline-block;
  overflow: auto;
}

.largeAttach-list li {
  line-height: 26px;
  padding: 2px 10px;
  color: #24324c;
}

.largeAttach-list li:hover {
  background-color: #FAFAFB;
}

.largeAttach-list li.selected {
  background-color: #E9F3FF;
}

/deep/ #largeFilePicker .webuploader-pick {
  width: 112px;
  height: 40px
}

/deep/ .fj_box .el-collapse-item__header {
  background: #F5F7FA;
  padding: 0 0 0 10px;
  height: 35px !important;
  line-height: 35px !important;
  border-radius: 2px;
  color: #00102F;
}

/deep/ .fj_box .el-collapse-item__header i {
  color: #00102F;
}

.addr-div {
  display: inline;
  float: left;
  cursor: pointer;
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/views/layout/boxWrite.vue